     $(document).ready(function () {

  var queryStringg = window.location.search;
  var urlParamss = new URLSearchParams(queryStringg);
  var selected_url = urlParamss.get('selected');
  if(selected_url != ''){
    if(selected_url == 'classic'){
      window.fromUrl = true;
      $('.paints-variant-input[value="Classic"]').parent().click()
      $('.paints-variant-input[value="Classic"]').prop('checked', false);
    }else if(selected_url == 'superior'){
      window.fromUrl = true;
      $('.paints-variant-input[value="Superior"]').parent().click()
      $('.paints-variant-input[value="Superior"]').prop('checked', false);
    }else if(selected_url == 'lak'){
      window.fromUrl = true;
      $('.sunkissed_dune_radio-option[sunkissedpro="sunkissed-dune-lak"]').click()
      $('[muurverf-collectie="Lakverf"] input[value="Mat"]').parent().click()
      $('[muurverf-collectie="Lakverf"] input[value="Mat"]').prop('checked', false)
    }else if(selected_url == 'wall_scrub'){
      window.fromUrl = true;
      $('.sunkissed_dune_radio-option[sunkissedpro="sunkissed-dune-wall-scrub"]').click()
      $('[muurverf-collectie="Wall Scrub"] input[value="Wall Scrub"]').parent().click()
      $('[muurverf-collectie="Wall Scrub"] input[value="Wall Scrub"]').prop('checked', false)
    }
    
  }
  
  let currentStep = 0; 

  
  // Full mapping of color suggestions based on collection handles and styles
  
const colorSuggestions = {
   "8-shades-of-off-white": {
    "Metropolitan Luxury": ["linen-muurverf", "ivory-muurverf", "selenite-muurverf"],
    "Japandi/Skandi": ["ivory-muurverf", "linen-muurverf", "glacier-muurverf"],
    "Donker/Moody": ["moon-muurverf", "linen-muurverf", "ivory-muurverf"],
    "Cosy/ Warm": ["linen-muurverf", "ivory-muurverf", "selenite-muurverf"],
    "Klassiek": ["linen-muurverf", "ivory-muurverf", "selenite-muurverf"],
    "Earthy": ["linen-muurverf", "ivory-muurverf", "selenite-muurverf"],
    "Minimalistisch": ["ivory-muurverf", "linen-muurverf", "glacier-muurverf"],
    "Pastel": ["linen-muurverf", "ivory-muurverf", "selenite-muurverf"],
    "Kleurrijk": ["linen-muurverf", "ivory-muurverf", "selenite-muurverf"],
    "Landelijk": ["linen-muurverf", "ivory-muurverf", "selenite-muurverf"]
},
"8-shades-of-originals": {
    "Metropolitan Luxury": ["dune-muurverf", "desert-muurverf", "clay-muurverf"],
    "Japandi/Skandi": ["coral-muurverf", "dune-muurverf", "desert-muurverf"],
    "Donker/Moody": ["quartz-muurverf", "clay-muurverf", "soil-muurverf"],
    "Cosy/ Warm": ["dune-muurverf", "desert-muurverf", "clay-muurverf"],
    "Klassiek": ["dune-muurverf", "desert-muurverf", "clay-muurverf"],
    "Earthy": ["dune-muurverf", "desert-muurverf", "clay-muurverf"],
    "Minimalistisch": ["coral-muurverf", "dune-muurverf", "desert-muurverf"],
    "Pastel": ["dune-muurverf", "desert-muurverf", "clay-muurverf"],
    "Kleurrijk": ["dune-muurverf", "desert-muurverf", "clay-muurverf"],
    "Landelijk": ["dune-muurverf", "desert-muurverf", "clay-muurverf"]
},
"8-shades-of-taupe": {
    "Metropolitan Luxury": ["fawn-muurverf", "silt-muurverf", "feather-muurverf"],
    "Japandi/Skandi": ["mineral-muurverf", "wheat-muurverf", "twill-muurverf"],
    "Donker/Moody": ["feather-muurverf", "basalt-muurverf", "shadow-muurverf"],
    "Cosy/ Warm": ["fawn-muurverf", "silt-muurverf", "feather-muurverf"],
    "Klassiek": ["fawn-muurverf", "silt-muurverf", "feather-muurverf"],
    "Earthy": ["fawn-muurverf", "silt-muurverf", "feather-muurverf"],
    "Minimalistisch": ["mineral-muurverf", "wheat-muurverf", "twill-muurverf"],
    "Pastel": ["fawn-muurverf", "silt-muurverf", "feather-muurverf"],
    "Kleurrijk": ["fawn-muurverf", "silt-muurverf", "feather-muurverf"],
    "Landelijk": ["fawn-muurverf", "silt-muurverf", "feather-muurverf"]
},
  "8-shades-of-mustard": {
    "Metropolitan Luxury": ["spice-muurverf", "saffron-muurverf", "amber-muurverf"],
    "Japandi/Skandi": ["sunlit-muurverf", "dijon-muurverf", "spice-muurverf"],
    "Donker/Moody": ["amber-muurverf", "harvest-muurverf", "ash-muurverf"],
    "Cosy/ Warm": ["spice-muurverf", "saffron-muurverf", "amber-muurverf"],
    "Klassiek": ["spice-muurverf", "saffron-muurverf", "amber-muurverf"],
    "Earthy": ["spice-muurverf", "saffron-muurverf", "amber-muurverf"],
    "Minimalistisch": ["sunlit-muurverf", "dijon-muurverf", "spice-muurverf"],
    "Pastel": ["spice-muurverf", "saffron-muurverf", "amber-muurverf"],
    "Kleurrijk": ["spice-muurverf", "saffron-muurverf", "amber-muurverf"],
    "Landelijk": ["spice-muurverf", "saffron-muurverf", "amber-muurverf"]
},
"8-shades-of-brown": {
    "Metropolitan Luxury": ["hazel-muurverf", "sandstone-muurverf", "sienna-muurverf"],
    "Japandi/Skandi": ["grain-muurverf", "hazel-muurverf", "sandstone-muurverf"],
    "Donker/Moody": ["bark-muurverf", "onyx-muurverf", "cocoa-muurverf"],
    "Cosy/ Warm": ["hazel-muurverf", "sandstone-muurverf", "sienna-muurverf"],
    "Klassiek": ["hazel-muurverf", "sandstone-muurverf", "sienna-muurverf"],
    "Earthy": ["hazel-muurverf", "sandstone-muurverf", "sienna-muurverf"],
    "Minimalistisch": ["grain-muurverf", "hazel-muurverf", "sandstone-muurverf"],
    "Pastel": ["hazel-muurverf", "sandstone-muurverf", "sienna-muurverf"],
    "Kleurrijk": ["hazel-muurverf", "sandstone-muurverf", "sienna-muurverf"],
    "Landelijk": ["hazel-muurverf", "sandstone-muurverf", "sienna-muurverf"]
},
"8-shades-of-green": {
    "Metropolitan Luxury": ["pasture-muurverf", "moss-muurverf", "fern-muurverf"],
    "Japandi/Skandi": ["willow-muurverf", "verdant-muurverf", "pasture-muurverf"],
    "Donker/Moody": ["emerald-muurverf", "slate-muurverf", "forest-muurverf"],
    "Cosy/ Warm": ["pasture-muurverf", "moss-muurverf", "fern-muurverf"],
    "Klassiek": ["pasture-muurverf", "verdant-muurverf", "moss-muurverf"],
    "Earthy": ["pasture-muurverf", "moss-muurverf", "fern-muurverf"],
    "Minimalistisch": ["willow-muurverf", "verdant-muurverf", "pasture-muurverf"],
    "Pastel": ["pasture-muurverf", "moss-muurverf", "fern-muurverf"],
    "Kleurrijk": ["pasture-muurverf", "moss-muurverf", "fern-muurverf"],
    "Landelijk": ["pasture-muurverf", "moss-muurverf", "fern-muurverf"]
},
"8-shades-of-blue": {
    "Metropolitan Luxury": ["saphr-muurverf", "cobalt-muurverf", "ocean-muurverf"],
    "Japandi/Skandi": ["sky-muurverf", "frostbite-muurverf", "lagoon-muurverf"],
    "Donker/Moody": ["saphr-muurverf", "ocean-muurverf", "night-muurverf"],
    "Cosy/ Warm": ["saphr-muurverf", "cobalt-muurverf", "ocean-muurverf"],
    "Klassiek": ["saphr-muurverf", "cobalt-muurverf", "ocean-muurverf"],
    "Earthy": ["saphr-muurverf", "cobalt-muurverf", "ocean-muurverf"],
    "Minimalistisch": ["sky-muurverf", "frostbite-muurverf", "lagoon-muurverf"],
    "Pastel": ["saphr-muurverf", "cobalt-muurverf", "ocean-muurverf"],
    "Kleurrijk": ["saphr-muurverf", "cobalt-muurverf", "ocean-muurverf"],
    "Landelijk": ["saphr-muurverf", "cobalt-muurverf", "ocean-muurverf"]
},
"8-shades-of-grey": {
    "Metropolitan Luxury": ["opal-muurverf", "sands-muurverf", "flint-muurverf"],
    "Japandi/Skandi": ["loam-muurverf", "drift-muurverf", "sands-muurverf"],
    "Donker/Moody": ["hearth-muurverf", "flint-muurverf", "graphite-muurverf"],
    "Cosy/ Warm": ["opal-muurverf", "sands-muurverf", "flint-muurverf"],
    "Klassiek": ["opal-muurverf", "sands-muurverf", "flint-muurverf"],
    "Earthy": ["opal-muurverf", "sands-muurverf", "flint-muurverf"],
    "Minimalistisch": ["loam-muurverf", "drift-muurverf", "sands-muurverf"],
    "Pastel": ["opal-muurverf", "sands-muurverf", "flint-muurverf"],
    "Kleurrijk": ["opal-muurverf", "sands-muurverf", "flint-muurverf"],
    "Landelijk": ["opal-muurverf", "sands-muurverf", "flint-muurverf"]
},
"8-shades-of-plum": {
    "Metropolitan Luxury": ["petal-muurverf", "amethyst-muurverf", "plum-muurverf"],
    "Japandi/Skandi": ["orchid-muurverf", "petal-muurverf", "amethyst-muurverf"],
    "Donker/Moody": ["plum-muurverf", "fig-muurverf", "berry-muurverf"],
    "Cosy/ Warm": ["petal-muurverf", "amethyst-muurverf", "plum-muurverf"],
    "Klassiek": ["petal-muurverf", "amethyst-muurverf", "plum-muurverf"],
    "Earthy": ["petal-muurverf", "amethyst-muurverf", "plum-muurverf"],
    "Minimalistisch": ["orchid-muurverf", "petal-muurverf", "amethyst-muurverf"],
    "Pastel": ["petal-muurverf", "amethyst-muurverf", "plum-muurverf"],
    "Kleurrijk": ["petal-muurverf", "amethyst-muurverf", "plum-muurverf"],
    "Landelijk": ["petal-muurverf", "amethyst-muurverf", "plum-muurverf"]
},
"8-shades-of-nude": {
    "Metropolitan Luxury": ["rosewater-muurverf", "rosequartz-muurverf", "velvet-muurverf"],
    "Japandi/Skandi": ["blossom-muurverf", "pearl-muurverf", "rosewater-muurverf"],
    "Donker/Moody": ["rosequartz-muurverf", "boudoir-muurverf", "velvet-muurverf"],
    "Cosy/ Warm": ["rosewater-muurverf", "rosequartz-muurverf", "velvet-muurverf"],
    "Klassiek": ["rosewater-muurverf", "rosequartz-muurverf", "velvet-muurverf"],
    "Earthy": ["rosewater-muurverf", "rosequartz-muurverf", "velvet-muurverf"],
    "Minimalistisch": ["blossom-muurverf", "pearl-muurverf", "rosewater-muurverf"],
    "Pastel": ["rosewater-muurverf", "rosequartz-muurverf", "velvet-muurverf"],
    "Kleurrijk": ["rosewater-muurverf", "rosequartz-muurverf", "velvet-muurverf"],
    "Landelijk": ["rosewater-muurverf", "rosequartz-muurverf", "velvet-muurverf"]
},

// Add other collections as needed (mustard, brown, etc.)
};

  function fetchCollectionProducts() {
    // Clear previous results
    $('.result-products').empty();

    // Get selected collections and style
    const collectionHandles = [
        localStorage.getItem('collectionHandle1'),
        localStorage.getItem('collectionHandle2'),
        localStorage.getItem('collectionHandle3')
    ].filter(Boolean);

    const style = localStorage.getItem('dataValue3'); // Style selection
    console.log(collectionHandles,'collectionHandles')
    if (!collectionHandles.length) {
        $('.result-products').append('<p>No collections selected.</p>');
        return;
    }

    // Define product limits based on selected collections
    const productCounts = collectionHandles.length === 1 
        ? [3] 
        : collectionHandles.length === 2 
        ? [1, 2] 
        : [1, 1, 1];

    const maxProducts = 3; // Total number of products to display
    let fetchedProductCount = 0; // Counter to track products added to DOM

    // Generate suggestions for selected collections
    const suggestions = [];
    collectionHandles.forEach((handle, index) => {
        const colors = colorSuggestions[handle]?.[style]?.slice(0, productCounts[index]) || [];
        suggestions.push(...colors);
    });

    // Fetch products from each collection
    const fetchPromises = collectionHandles.map((collectionHandle, index) => {
        return new Promise((resolve) => {
            const apiUrl = `https://shadesbyerickuster.com/collections/${collectionHandle}`;
            console.log('Fetching from:', apiUrl);

            $.ajax({
                url: apiUrl,
                method: 'GET',
                success: function (response) {
                    const $response = $(response);
                    console.log(`Collection ${index + 1} HTML Response received.`);

                    const products = $response.find('.mps-slide-for');
                    const filteredProducts = products.filter(function () {
                        const productHandle = $(this).data('handle');
                        return suggestions.includes(productHandle);
                    }).slice(0, productCounts[index]);
                    resolve(filteredProducts.toArray()); // Return as an array
                },
                error: function (xhr, status, error) {
                    console.error(`Error fetching products for Collection ${index + 1}:`, error);
                    resolve([]); // Resolve with an empty array on error
                }
            });
        });
    });

    Promise.all(fetchPromises).then((allProducts) => {
        const flattenedProducts = allProducts.flat();

        // Append products to the DOM
        flattenedProducts.slice(0, maxProducts).forEach((product) => {
            const productHtml = $(product).clone(); // Ensure it's a jQuery object
            $('.result-products').append(productHtml);
            fetchedProductCount++;
            console.log(fetchedProductCount,'fetchedProductCount')
        });

        // If not enough products found
        if (fetchedProductCount < maxProducts) {
            $('.result-products').append('<p>Not enough products found to meet the selection criteria.</p>');
        }
    });
}


// Trigger the product fetching process
fetchCollectionProducts();
  
// Start the quiz and show step 1
$(document).on('click', '.quiz_start span', function () {
  localStorage.removeItem('dataValue1');
  localStorage.removeItem('dataValue3');
  localStorage.removeItem('dataValue5');
  localStorage.removeItem('dataValue6');
  localStorage.removeItem('collectionHandle1');
  localStorage.removeItem('collectionHandle2');
  localStorage.removeItem('collectionHandle3');
  localStorage.removeItem('style');
  $('.before_quiz_start').hide();
 
  currentStep = 1; // Initialize the first step
  updateSteps(currentStep); // Start with Step 1
   let baseUrl = window.location.href;
   let newUrl = `${baseUrl}?page=${currentStep}`;
   history.pushState(null, '', newUrl);
  $('.quiz-step-pagination').show();
  $('.steps_container .page-width.bread').show();
  Shopify.analytics.publish('custom_event', {
    event: "quiz_0_start",
  });
});
var storedValue1;
var storedValue3;
var storedValue5;
var storedValue6;

// Handle selection in step1
$(document).on('click', '.step1 .quiz_select_data', function () {
  $('.quiz_select_data').removeClass('active');
  $(this).addClass('active');
  const value = $(this).find('.quiz_column').data('value');
  localStorage.setItem('dataValue1', value);
  $('.before_quiz_start').attr('data-step1-selection', value);
  $('.step2-selection').text(value);
  $('#question_1').val(value);
  if(value == 'Kantoor'){
   $('.step1ans').text('het '+value);
  }else{
   $('.step1ans').text('de '+value);
  }
  
  $('.right-arrow').prop('disabled', false);
  $('.right-arrow').trigger('click');
  window.quiz_room1_val = value;
  Shopify.analytics.publish('custom_event', {
    event: "quiz_1_room",
    quiz_1_room: value,
  });
});

// Handle selection in step2
$(document).on('change', '.step_2-selection input[type="radio"]', function () {
  const selectedValue = $(this).val(); // Get the value of the selected radio button
  $('.before_quiz_start').attr('data-step2-selection', selectedValue);
  $('#question_2').val(selectedValue);
  $('.right-arrow').prop('disabled', false);
  $('.right-arrow').trigger('click');
  window.quiz_room2_val = selectedValue;
  Shopify.analytics.publish('custom_event', {
    event: "quiz_2_more",
    quiz_1_room: window.quiz_room1_val,
    quiz_2_more: selectedValue ,
  });
});

// Handle selection in step3
$(document).on('click', '.step3 .quiz_select_data', function () {
  $('.quiz_select_data').removeClass('active');
  $(this).addClass('active');
  const value = $(this).find('.quiz_column').data('value');
  $('.before_quiz_start').attr('data-step3-selection', value);
  localStorage.setItem('dataValue3', value);      
  $('.step4-selection').text(value);
  $('#question_3').val(value);
  $('.right-arrow').prop('disabled', false);
  $('.right-arrow').trigger('click');
  window.quiz_room3_val = value
  Shopify.analytics.publish('custom_event', {
  event: "quiz_3_atmosphere",
  quiz_1_room: window.quiz_room1_val, 
  quiz_2_more: window.quiz_room2_val,
  quiz_3_atmosphere: value,
  });
});

// Handle selection in step4
  $(document).on('click', '.step4 .quiz_select_data', function () {
  $(this).toggleClass('active');
  const selectedValues = $('.step4 .quiz_select_data.active').map(function () {
      return $(this).find('.quiz_column').data('value');
  }).get();
  if (selectedValues.length > 2) {
      $(this).removeClass('active');
      return;
  }
  $('.before_quiz_start').attr('data-step4-selection', selectedValues.join(', '));
  $('.step5-selection').text(selectedValues.join(', '));
  $('#question_4').val(selectedValues.join(', '));
  $('.right-arrow').prop('disabled', selectedValues.length === 0);
     if (selectedValues.length === 2) { 
    $('.right-arrow').trigger('click');
  }
  window.quiz_room4_val = selectedValues;
  Shopify.analytics.publish('custom_event', {
    event: "quiz_4_orientation",
    quiz_1_room: window.quiz_room1_val,
    quiz_2_more: window.quiz_room2_val,
    quiz_3_atmosphere: window.quiz_room3_val,
    quiz_4_orientation: selectedValues,
  });
});

// Handle selection in step5
$(document).on('click', '.step5 .quiz_select_data', function () {
  $('.quiz_select_data').removeClass('active');
  $(this).addClass('active');
  const value = $(this).find('.quiz_column').data('value');
  $('.before_quiz_start').attr('data-step5-selection', value);
  localStorage.setItem('dataValue5', value);      
  $('#question_5').val(value);
  $('.right-arrow').prop('disabled', false);
  $('.right-arrow').trigger('click');
  window.quiz_room5_val = value;
  Shopify.analytics.publish('custom_event', {
    event: "quiz_5_size",
    quiz_1_room: window.quiz_room1_val,
    quiz_2_more: window.quiz_room2_val,
    quiz_3_atmosphere: window.quiz_room3_val, 
    quiz_4_orientation: window.quiz_room4_val,
    quiz_5_size: value,
  });
});

// Handle selection in step6
$(document).on('click', '.step6 .quiz_select_data', function () {
  $('.quiz_select_data').removeClass('active');
  $(this).addClass('active');
  const value = $(this).find('.quiz_column').data('value');
  $('.before_quiz_start').attr('data-step6-selection', value);
  localStorage.setItem('dataValue6', value);      
  $('#question_6').val(value);
  $('.right-arrow').prop('disabled', false);
  $('.right-arrow').trigger('click');
  window.quiz_room6_val = value;
  Shopify.analytics.publish('custom_event', {
    event: "quiz_6_daylight",
    quiz_1_room: window.quiz_room1_val,
    quiz_2_more: window.quiz_room2_val,
    quiz_3_atmosphere: window.quiz_room3_val, 
    quiz_4_orientation: window.quiz_room4_val,
    quiz_5_size:  window.quiz_room5_val,
    quiz_6_daylight: value,
  });
});

$(document).on('click', '.step7 .quiz_select_data', function () {
  const activeItemsCount = $('.step7 .quiz_select_data.active').length;

  if ($(this).hasClass('active')) {
      $(this).toggleClass('active');
  } else if (activeItemsCount < 3) {
      $(this).toggleClass('active');
  } else {
      alert('You can only select up to 3 items.');
  }

  // Collect selected values
  const selectedValues = $('.step7 .quiz_select_data.active').map(function () {
      return $(this).find('.quiz_column').data('value');
  }).get();

  // Update the attributes dynamically based on the selected values
  $('.before_quiz_start')
      .attr('data-step7-collection1', selectedValues[0] || '')
      .attr('data-step7-collection2', selectedValues[1] || '')
      .attr('data-step7-collection3', selectedValues[2] || '');
  localStorage.removeItem('collectionHandle1');
  localStorage.removeItem('collectionHandle2');
  localStorage.removeItem('collectionHandle3');
  localStorage.removeItem('style'); // Optional: Clear style if needed

  // Save the selected values to local storage
  localStorage.setItem('collectionHandle1', selectedValues[0] || '');
  localStorage.setItem('collectionHandle2', selectedValues[1] || '');
  localStorage.setItem('collectionHandle3', selectedValues[2] || '');

  // Update the hidden input field
  $('#question_7').val(selectedValues.join(', '));
  $('.right-arrow').addClass('collection-result');

  // If at least one collection is selected, enable the right arrow button
  if (selectedValues.length > 0) {
      $('.right-arrow').prop('disabled', false);

      // Trigger the fetchCollectionProducts function
  } else {
      $('.right-arrow').prop('disabled', true);
  }
  if (selectedValues.length === 3) {
    $('.right-arrow').trigger('click');
  }
  window.quiz_room7_val = [selectedValues[0], selectedValues[1], selectedValues[2]];
  Shopify.analytics.publish('custom_event', {
    event: "quiz_7_colors",
    quiz_1_room: window.quiz_room1_val,
    quiz_2_more: window.quiz_room2_val,
    quiz_3_atmosphere: window.quiz_room3_val, 
    quiz_4_orientation: window.quiz_room4_val,
    quiz_5_size:  window.quiz_room5_val,
    quiz_6_daylight: window.quiz_room6_val,
    quiz_7_colors: [selectedValues[0], selectedValues[1], selectedValues[2]],
  });
});


  $(document).on('click', '.collection-result', function () {
    fetchCollectionProducts();
  });
  
  function updateSteps(currentStep) {
    // Hide all steps
    $('.steps_container > div').hide();

    // Show the current step
    $(`.steps_container > div[data-step="${currentStep}"]`).css('display','block');

    // Update left and right arrow
    const totalSteps = $('.steps_container > div').length;
    $('.left-arrow').prop('disabled', currentStep === 1);
    $('.right-arrow').prop('disabled', currentStep === 1 || currentStep === totalSteps);

    // Update scrollbar
    const progress = (currentStep / totalSteps) * 100;
    $('.scroll-progress').css('width', `${progress}%`);
  }

  // Handle left arrow click
  $(document).on('click', '.left-arrow', function () {
    if (currentStep > 1) {
      currentStep -= 1;
      updateSteps(currentStep);
    }
    $('.crnt-page').text(currentStep);
     let url = new URL(window.location.href);
     url.searchParams.set("page", currentStep);
     history.replaceState(null, '', url.toString());
    $('.steps_container .page-width.bread').show();
    $('html, body').animate({
      scrollTop: $('.steps_container').offset().top
      }, 10);
  });

  $(document).ready(function () {
    if (window.location.pathname.includes("/pages/quiz")) {
        let url = new URL(window.location.href);
        if (url.searchParams.has("page")) {
            url.searchParams.delete("page");
            history.replaceState(null, '', url.toString());
        }
    }
});

  // Handle right arrow click
 $(document).on('click', '.right-arrow', function () {
  const totalSteps = $('.steps_container > div').length;
  if (currentStep < totalSteps) {
    currentStep += 1;
    updateSteps(currentStep);
  }
  
  $('.crnt-page').text(currentStep);
    let url = new URL(window.location.href);
    url.searchParams.set("page", currentStep);
    history.replaceState(null, '', url.toString());
  if (currentStep === totalSteps) {
    $('.quiz-step-pagination').hide();
    $('.steps_container .page-width.bread').show();
    $('.steps_container .page-width.bread').hide();
    $('.quiz-mail').show();
    $('html, body').animate({
      scrollTop: $('.steps_container').offset().top
    }, 10);
  } else {
    $('.right-arrow').prop('disabled', true);
    $('.steps_container .page-width.bread').show();
    $('html, body').animate({
      scrollTop: $('.steps_container').offset().top
    }, 10);
  }
});

  // Prevent right-click context menu on navigation buttons
  $(document).on('contextmenu', '.left-arrow, .right-arrow', function (e) {
    e.preventDefault(); // Prevent the default right-click menu
  });


     window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.type == 'submit') {
        if(document.querySelector('.quiz-mail')){
            document.querySelector('.quiz-mail').style.display = 'none';
        }
      if(document.querySelector('.quiz-success')){
            document.querySelector('.quiz-success').style.display = 'block';  
      }
            var storedValue1 = localStorage.getItem('dataValue1');
            var storedValue3 = localStorage.getItem('dataValue3');
            var storedValue5 = localStorage.getItem('dataValue5');
            var storedValue6 = localStorage.getItem('dataValue6');
            if(storedValue1 == 'Kantoor'){
             $('.data-1').text('het '+storedValue1);
            }else{
             $('.data-1').text('de '+storedValue1);
            }
            $('.data-3').text(storedValue3);
            $('.data-5').text(storedValue5);
            $('.data-6').text(storedValue6);
            $('.quiz-success').show();
           const usrname = e.detail.metaData["$first_name"];
            if (usrname) {
                $('#user_name').text(usrname);
            }  
            let url = new URL(window.location.href);
              let currentStep = parseInt(url.searchParams.get("page")) || 1;
              let nextStep = currentStep + 1;
              url.searchParams.set("page", nextStep);
              history.replaceState(null, '', url.toString());
               if (window.matchMedia("(max-width: 700px)").matches) {
                         var $slider = $('.quiz .result-products.test.grid.grid--uniform');
                          var $progressBar = $('.quiz .progress');
                          var $progressBarLabel = $('.quiz .slider__label');
                        
                          // Set initial progress bar width to 2% if it's the first slide
                          $progressBar
                            .css('background-size', '2% 100%')
                            .attr('aria-valuenow', 2);
                        
                          $progressBarLabel.text('2% completed');
                        
                          $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                            var calc;
                        
                            if (nextSlide === 0) {
                              // If it's the first slide, set the progress to 2%
                              calc = 2;
                            } else {
                              // For other slides, calculate progress normally
                              calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
                            }
                        
                            $progressBar
                              .css('background-size', calc + '% 100%')
                              .attr('aria-valuenow', calc);
                        
                            $progressBarLabel.text(calc + '% completed');
                          });
                        
                          $slider.not('.slick-initialized').slick({
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: false,
                                arrows: false,
                                centerMode: true,
                                centerPadding: '40px',
                               infinite:false
                          });           
                      }
              $('.result-products').slick('refresh');
      
              
             
      }
     });

 function jkshowoverlay(){
    if($("#jkoverlay").length)
    {
      $("#jkoverlay").show();
    }
    else
    {
    var overlay = $('<div id="jkoverlay"> </div>');
    overlay.appendTo(document.body)
    }
  }  
 
  function jkhideoverlay(){
    $("#jkoverlay").hide();  
  }   
    
  $("area-calculator").show();
    
  $(".selectfinish").on("click", function(){
    $("#selectfinish").attr("open","");
    jkshowoverlay();
  });

  $(".openinhouddialog").on("click", function(){
    if($('.ihselectcontent').html()=="")
    { 
    var bucketselector = $('.jkinhouddialog').detach();
      $('.ihselectcontent').append(bucketselector);
      $('.jkinhouddialog').show();
    }
    
    $("#selectInhouddialog").attr("open","");
    jkshowoverlay();
  });

  $(".openwhychoose").on("click", function(){
    var vrnt = $(this).parents('.dunmurffer_section').find('.jkselectedfinish').text();
    $('.whychoosedune').removeClass('display_block');
    $('.whychoosedune[data-thumb="'+vrnt+'"]').addClass('display_block');
    $('.whychoosedune[data-thumb="'+vrnt+'"]').css('display:block');
 
    $("#whychoosedune").attr("open","");
    jkshowoverlay();

    if(!$(".whychthumbwrap").hasClass("slick-initialized"))
    {
    $('.whychthumbwrap').slick({
      dots: false,
      vertical: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      verticalSwiping: true,
      arrows: false,
      asNavFor: '.whychimagewrap',
      focusOnSelect: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite:false,
            vertical: false,
            verticalSwiping: false
          }
        }
      ]
    });
    }

    if(!$(".whychimagewrap").hasClass("slick-initialized")){
    $('.whychimagewrap').slick({
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      verticalSwiping: true,
      arrows: true,
      adaptiveHeight: false,
      infinite: true,
      asNavFor: '.whychthumbwrap',
      prevArrow:'<button type="button" class="slick-prev pull-left"> <svg viewBox="0 0 100 100"> <path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path> </svg></button>',
      nextArrow:'<button type="button" class="slick-next pull-right"><svg viewBox="0 0 100 100"> <path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      responsive: [
          {
            breakpoint: 768,
            settings: {                           
              arrows:false,
              swipeToSlide: true
            }
          }
        ]  
    });
    }

    $('.whychthumbwrap').slick('refresh');
    $('.whychimagewrap').slick('refresh');
 
  });

  $(".jkdialogclose").on('click', function(){
    $(this).closest('dialog').removeAttr("open");
    jkhideoverlay();
  });

  function jkupdateaddtocart(curelm) {
    if(curelm.hasClass("jkoption"))//clicked on inhoud
    {
      var id1 = $(".jkfinselected").data("id").toString();
    }
    else //clicked on Finish
    {
      var id1 = $(".jkselected").data("id").toString();
    }
    var id2 = curelm.data("id").toString();
    var variantfound = false;
    $(".jkselvariant option").each(function(){
        var variantoptvals = $(this).data("optionvals");
      
        var variantoptvalarr = variantoptvals.split("_");
        if(($.inArray(id1, variantoptvalarr)!== -1) && ($.inArray(id2, variantoptvalarr)!== -1))//variant found
        {
          variantfound = true;
          $(".jkselvariant option").removeAttr("selected");
          $(this).attr("selected","");
          
          $(".atcprice").html("€" + (parseFloat($(this).data("price"))/100).toFixed(2).toString().replace('.',','));
          return false;
        }
      });
    return variantfound;
  }  
  $(".jkoption").on("click",function(){
    if($(".jkfinselected").length) //a finish has been selected already
    {
      if(!jkupdateaddtocart($(this)))
      {
        alert("This Inhoud is not available for the selected Finish.");
        return false;
      }
    }
    $(".jkselectedinhoud").html($(this).find("span").html());
    $(".jkselected").removeClass("jkselected");
    $(this).addClass("jkselected");
    $(this).closest('dialog').removeAttr("open");
    jkhideoverlay();
    var sss = $(this).find('img').attr('src');
    var dattaprice = $(this).find('img').attr('data-original-price');
    var dataDiscprice = $(this).find('img').attr('data-final-price');  
    var compareprice = $(this).find('img').attr('data-compare-price');

    var dattapriceNum = parseFloat(dattaprice.replace(/[^0-9.]/g, ''));
    var dataDiscpriceNum = parseFloat(dataDiscprice.replace(/[^0-9.]/g, ''));
     var comparepriceNum = parseFloat(compareprice.replace(/[^0-9.]/g, ''));
     
    function cleanPrice(price) {
      if (!price) return 0;
      let clean = price.toString().replace(/[€\s\-]/g, '');
      clean = clean.replace(',', '.');
      clean = clean.replace(/[^0-9.]/g, '');
      return parseFloat(clean);
    }

    var dattapriceNum = cleanPrice(dattaprice);
    var dataDiscpriceNum = cleanPrice(dataDiscprice);
    var comparepriceNum = cleanPrice(compareprice);

  if (!isNaN(dattapriceNum) && !isNaN(dataDiscpriceNum) && dattapriceNum !== dataDiscpriceNum) {
    $('.totaal-prices .product__price').text(dattaprice);
    // $('.pdp-total-price .act-price').addClass('line_thorugh');
    let dattaprice1 = '€' + parseFloat(dattaprice.replace(/[^0-9.]/g, '')).toFixed(0) + ',-';
    $('.pdp-total-price .act-price').text(dattaprice1);
    

    let formattedPrice = '€' + parseFloat(dataDiscprice.replace(/[^0-9.]/g, '')).toFixed(0) + ',-';
     $('.pdp-total-price .disc-price').text(formattedPrice);
    

  } else {
    console.log(comparepriceNum + 'compare price' + compareprice )
    $('.totaal-prices .product__price').text(dattaprice);
    // $('.pdp-total-price .act-price').removeClass('line_thorugh');
    let formattedPrice = '€' + parseFloat(dattaprice.replace(/[^0-9.]/g, '')).toFixed(0) + ',-';
    $('.pdp-total-price .act-price').text(formattedPrice);
    let compformattedPrice = '€' + parseFloat(compareprice.replace(/[^0-9.]/g, '')).toFixed(0) + ',-';
    console.log(compformattedPrice,'compformattedPrice')
    if(comparepriceNum > 0){
      $('.pdp-total-price .disc-price').text(compformattedPrice);
    }else{
      $('.pdp-total-price .disc-price').text('');
    }
  } 

    $('.dunemuurverf .color-hero').css('background-image', `url(${sss})`);
    });   

    function getTheVariantData(titless) {
      let result = {
        images: [],
        names: [],
        originalPrices: [],
        discounts: [],
        finalPrices: [],
        compareprice: [],
      };

    document.querySelectorAll('.imagess_variants div').forEach((items) => {
        const attr_h = items.getAttribute('data-variant-qty');
        if (attr_h && attr_h.includes(titless)) {
            result.images.push(items.getAttribute('data-variant-img'));
            result.names.push(attr_h);
            result.originalPrices.push(items.getAttribute('data-original-price'));
            result.discounts.push(items.getAttribute('data-discount'));
            result.finalPrices.push(items.getAttribute('data-final-price'));
            result.compareprice.push(items.getAttribute('data-compare-price'));
        }
    });

    return result; 
}

$(".optbox").on("click", function() {
    if ($(".jkselected").length) {
        if (!jkupdateaddtocart($(this))) {
            alert("This Finish is not available for the selected Inhoud.");
            return false;
        }
    }

    $(".jkselectedfinish").html($(this).find(".finishtitle").html());
    $(".jkfinselected").removeClass("jkfinselected");
    $(this).addClass("jkfinselected");
    $(this).closest('dialog').removeAttr("open");

    const titless = $(this).find('.finishtitle').text();
    const variantData = getTheVariantData(titless);

    // Update images, variant names, and prices
    document.querySelectorAll('.jkcontents .jkoption img').forEach((items, index) => {
      console.log(variantData,'variantDatavariantData')
        items.setAttribute('src', variantData.images[index]);
        items.setAttribute('data-variant-name', variantData.names[index]);
        items.setAttribute('data-original-price', variantData.originalPrices[index]);
        items.setAttribute('data-discount', variantData.discounts[index]);
        items.setAttribute('data-final-price', variantData.finalPrices[index]);
        items.setAttribute('data-compare-price', variantData.compareprice[index]);
    });

    jkhideoverlay();
    $('.jkoption.jkselected').click(); 
});



  $(".jkoption").first().click();
  $(".optbox").first().next().click();  
  
  $('.jkslick').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: false,
    variableWidth: true,
    prevArrow: $('.jkprev'),
    nextArrow: $('.jknext'),
    customPaging : function(slider, i) {
        return '<img src="https://cdn.shopify.com/s/files/1/0731/9388/1903/files/dot.png?v=1730064623" /><img src="https://cdn.shopify.com/s/files/1/0731/9388/1903/files/dotactive.png?v=1730064623" />';
    },
    
  });

  if($("body.dunemuurverf .product_of_coll").length)
  {
    $('body.dunemuurverf .product_of_coll').slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: true,
                    dots:false,
                    prevArrow: '<button class="top_bar_slick-arrows previous"><svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.06613 0.37828C6.02776 0.285131 5.96696 0.202914 5.88913 0.138951C5.8113 0.0749873 5.71886 0.0312619 5.62004 0.0116678C5.52122 -0.00792629 5.4191 -0.00278101 5.32275 0.0266455C5.2264 0.0560719 5.13882 0.108866 5.06782 0.180328L0.180128 5.06802C0.123232 5.12477 0.0780897 5.19219 0.0472898 5.26642C0.01649 5.34064 0.000636101 5.42022 0.000636101 5.50058C0.000636101 5.58094 0.01649 5.66051 0.0472898 5.73474C0.0780897 5.80897 0.123232 5.87639 0.180128 5.93314L5.06782 10.8208C5.18254 10.9356 5.33814 11 5.50038 11C5.66262 11 5.81822 10.9356 5.93294 10.8208C6.04766 10.7061 6.11211 10.5505 6.11211 10.3883C6.11211 10.226 6.04766 10.0704 5.93294 9.95571L2.08755 6.11154H15.2758C15.4378 6.11154 15.5932 6.04717 15.7078 5.93259C15.8223 5.81802 15.8867 5.66262 15.8867 5.50058C15.8867 5.33854 15.8223 5.18314 15.7078 5.06856C15.5932 4.95399 15.4378 4.88962 15.2758 4.88962H2.08755L5.93294 1.04545C6.01878 0.959975 6.07727 0.850913 6.10099 0.732118C6.1247 0.613324 6.11257 0.490162 6.06613 0.37828Z" fill="black"/></svg></button>',
                    nextArrow: '<button class="top_bar_slick-arrows nxt"><svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.82059 0.37828C9.85896 0.285131 9.91976 0.202914 9.99759 0.138951C10.0754 0.0749873 10.1679 0.0312619 10.2667 0.0116678C10.3655 -0.00792629 10.4676 -0.00278101 10.564 0.0266455C10.6603 0.0560719 10.7479 0.108866 10.8189 0.180328L15.7066 5.06802C15.7635 5.12477 15.8086 5.19219 15.8394 5.26642C15.8702 5.34064 15.8861 5.42022 15.8861 5.50058C15.8861 5.58094 15.8702 5.66051 15.8394 5.73474C15.8086 5.80897 15.7635 5.87639 15.7066 5.93314L10.8189 10.8208C10.7042 10.9356 10.5486 11 10.3863 11C10.2241 11 10.0685 10.9356 9.95378 10.8208C9.83906 10.7061 9.77461 10.5505 9.77461 10.3883C9.77461 10.226 9.83906 10.0704 9.95378 9.95571L13.7992 6.11154H0.610961C0.448924 6.11154 0.293524 6.04717 0.178946 5.93259C0.0643689 5.81802 0 5.66262 0 5.50058C0 5.33854 0.0643689 5.18314 0.178946 5.06856C0.293524 4.95399 0.448924 4.88962 0.610961 4.88962H13.7992L9.95378 1.04545C9.86794 0.959975 9.80944 0.850913 9.78573 0.732118C9.76201 0.613324 9.77415 0.490162 9.82059 0.37828Z" fill="black"/></svg></button>',
                    responsive: [
                      {
                          breakpoint: 980, // tablet breakpoint
                          settings: {
                              slidesToShow: 3
                          }
                      },
                      {
                          breakpoint: 550, // mobile breakpoint
                          settings: {
                              slidesToShow: 1,
                              dots: true,
                              arrows: false
                          }
                      }
                  ]
                    
        });
  }

  /* Add Facebook, Google Ads and GA4 IDs to cart attributes */
  function getCookie(name) {
    let cookie = {};
    document.cookie.split(";").forEach(function (el) {
      let split = el.split("=");
      cookie[split[0].trim()] = split.slice(1).join("=");
    });
    return cookie[name];
  }

  function getGaClientId() {
    const cookie = getCookie("_ga");
    if (!cookie) return undefined;
    return cookie.split(".").slice(2).join(".");
  }

  function getGaSessionId() {
    const cookie = getCookie("_ga_HQ2TWX8RBP"); // TODO Do not hardcode this
    if (!cookie) return undefined;
    return parseInt(cookie.split(".")[2]);
  }

  function getGaSessionCount() {
    const cookie = getCookie("_ga_HQ2TWX8RBP"); // TODO Do not hardcode this
    if (!cookie) return undefined;
    return parseInt(cookie.split(".")[3]);
  }

  function getShopifyClientId() {
    // return ShopifyAnalytics.lib.user().traits().uniqToken;
    const cookie = getCookie("_shopify_y");
    if (!cookie) return undefined;
    return cookie;
  }

  function getShopifySessionId() {
    const cookie = getCookie("_shopify_s");
    if (!cookie) return undefined;
    return cookie;
  }

  const params = new URLSearchParams(document.location.search);
  const fbclid = params.get("fbclid");
  const gclid = params.get("gclid");
  const gaClientId = getGaClientId();
  const gaSessionId = getGaSessionId();
  const gaSessionCount = getGaSessionCount();
  const shopifyClientId = getShopifyClientId();
  const shopifySessionId = getShopifySessionId();

  if (
    fbclid ||
    gclid ||
    gaClientId ||
    gaSessionId ||
    gaSessionCount ||
    shopifyClientId ||
    shopifySessionId
  ) {
    let formData = new FormData();

    if (fbclid) formData.append("attributes[_fbclid]", fbclid);
    if (gclid) formData.append("attributes[_gclid]", gclid);
    if (gaClientId) formData.append("attributes[_cid]", gaClientId);
    if (gaSessionId) formData.append("attributes[_sid]", gaSessionId);
    if (gaSessionCount) formData.append("attributes[_sct]", gaSessionCount);
    if (shopifyClientId)
      formData.append("attributes[_shopify_y]", shopifyClientId);
    if (shopifySessionId)
      formData.append("attributes[_shopify_s]", shopifySessionId);

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        console.log("added attributes to cart:", data);
      });
  }
});

  $('button.see_more_text').click(function (params) {
      $(this).parent().find('.Full_content_show').toggleClass('active');
      $(this).parent().find('.intro_txt.less_content_show').toggleClass('active');
  })
    $('.intro_slider_section_ab_testing').slick({
           slidesToShow: 1,
           slidesToScroll: 1,
           arrows: true,
           fade: true,
           infinite: false,
           prevArrow: '<button class="Ab_testing_prevarrow"><svg width="20" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
           nextArrow: '<button class="Ab_testing_nextarrow"><svg width="20" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
           responsive: [
                  {
                 breakpoint: 768,
                 settings: {
                   slidesToShow: 1,
                   slidesToScroll: 1,
                   arrows: true,
                 }
               }
           ]
     });


/* project pages js */

$(document).on('click','.sunkissed-dune.sample-of-packs #jkoverlay',function(){
  $('.cross_the_pro_modal img').click()
   $('.jkdialogclose').click()
});
$(document).on('click', function(event) {
    const $button = $('.sample_complete_look_slider .variant-name-option button');
    const $ul = $button.next('ul');
    if (!$(event.target).closest($button).length && !$(event.target).closest($ul).length) {
        $ul.removeClass('show_vrnts_ul');
    }
});

function changesprice(quty){
  if($('.sunkissed-variants-show').hasClass('checked_variant')){
    let price = $('.checked_variant').attr('singleprice');
    let qty = parseInt(quty);
    let qtty = parseInt(quty);
    let total = price * qty;
    let tottal = price * qtty;
    let formattedTotal = (total / 100).toFixed(2).replace('.', ',');
    let mobformattedTotal = (tottal / 100).toFixed(2).replace('.', ',');


    $('.product-block.sample-pack-addtocart .product__pricess').text('€'+ formattedTotal);
    $('.sunkissed_sticky-cart .product__prices').text('€'+ mobformattedTotal);
     $('.newdesign .inspired_add_to_cart b').text(' €'+ formattedTotal);
 
  }
  var actualprice, discprice, compareprice;

// Check if data-compare-price exists and has value
if ($('span.act-price.line_thorugh[data-cmpare-price]').length > 0) {
    actualprice = $('span.act-price.line_thorugh').attr('data-cmpare-price');
    discprice = $('span.disc-price').attr('data-disc-price');
} 
else {
    actualprice = $('.product-block.product-block--price .totaal-prices').attr('pro_price');
    discprice = $('.product-block.product-block--price .totaal-prices').attr('prod_disc_price');
    compareprice = $('.product-block.product-block--price .totaal-prices').attr('pro_comp_price');
}

    if (typeof actualprice !== "undefined" && typeof discprice !== "undefined") {
    var actualprices = actualprice.replace('€', '').trim().replace(',', '.');
    var discprices = discprice.replace('€', '').trim().replace(',', '.');
    var multicomprreprice = actualprices*quty;
    var multidiscprices = discprices*quty;
    var finalcomPrice = '€' + multicomprreprice.toFixed(0);
    var finaldiscPrice = '€' + multidiscprices.toFixed(0);
    
    $('.change-the-price span.act-price.line_thorugh').text(finalcomPrice+',-');
    // $('.change-the-price span.disc-price').text(finaldiscPrice+',-');
    $('.newdesign .inspired_add_to_cart b').text(' '+finalcomPrice+',-');
    }
    else{
       actualprice = $('span.act-price').attr('data-cmpare-price');
        var actualprices = actualprice.replace('€', '').trim().replace(',', '.');
         var multicomprreprice = actualprices*quty;
         var finalcomPrice = '€' + multicomprreprice.toFixed(0);
          $('.change-the-price span.act-price').text(finalcomPrice+',-');
 
          compareprice = $('li.sunkissed-variants.sunkissed-variants-show.checked_variant img').attr('data-compare-price');
          if (!isNaN(compareprice) && compareprice !== 0) {
          var compareprices = compareprice.replace('€', '').trim().replace(',', '.');
          var multicomprreprices = compareprices*quty;
          var finalcomPrices = '€' + multicomprreprices.toFixed(0);
          $('.change-the-price span.disc-price').text(finalcomPrices+',-');
          }  
    }
    if($('body').hasClass('ctm-color_card_2025') || $('body').hasClass('ctm-sample-of-pack')){
      var actualprice = parseInt($('.pdp-total .act-price').attr('data-cmpare-price'), 10);
      var colorqtty = $('.product__quantity input.js-qty__num').val();
      var pp = actualprice*colorqtty;
      $('.pdp-total .act-price').text('€'+pp+',-');
       cashback()
    }
}
function changesvrntliter(){
  let qtty = parseFloat($('.select_the_pro_modal_qty .product__quantity input').val());
   let tittle = $('.checked_variant').attr('title');
    let match = tittle.match(/\d+(\.\d+)?/); 
    let numberOnly = match ? match[0] : null;
    $('.sunkissed_sticky_hoeveelheid span').text(numberOnly + 'L' +' | '+ qtty+'x')
   $('.sunkissed_sticky_hoeveelheid').addClass('border-font-bold');
}

/* end project pages */
$(document).on('click','.sample-of-packs .color_guide-contents button.js-qty__adjust--plus,.select_the_pro_modal_qty .js-qty__adjust--plus',function(){
  var v = parseInt($(this).siblings(".js-qty__num").val());
    $(this).siblings(".js-qty__num").val(v + 1);
    var qtty = v+1;
   changesprice(qtty);
  changesvrntliter()
});
$(document).on('click','.sample-of-packs .color_guide-contents button.js-qty__adjust--minus,.select_the_pro_modal_qty .js-qty__adjust--minus',function(){
   var v = parseInt($(this).siblings(".js-qty__num").val());
  if(v > 1){
    $(this).siblings(".js-qty__num").val(v - 1);
    var qtty = v-1;
    changesprice(qtty);
  }
    

  
  changesvrntliter()
});


function addToCart(sampleid, quantity, button, triggerStepClick = false) {
    $.ajax({
        url: "/cart/add.js",
        type: "post",
        data: { id: sampleid, quantity: quantity },
        success: function(productt) {
          if($("body").hasClass("sunkissed-dune-muurverf") || $("body").hasClass("color_template_sunkissed")){
            $('.cv4-step-step:nth-child(4)').click();
          }else{
             $('.cv4-step-step:nth-child(2)').click();
          }          
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                    product: productt,
                    addToCartBtn: button
                }
            }));

            Shopify.analytics.publish('cart_viewed', {
                id: sampleid, // Assuming sampleid == proid
                product: productt
            });
        },
        error: function() {
            // Optional error handling
        }
    });
}

$(document).on('click','.product-block.sample-pack-addtocart button, .samples_pro .adding-cart, .inspired_add_to_cart,.variant-name-option .adding-cart',function() {
    const $btn = $(this);
    const sampleid = $btn.attr('sampleid');
    let quantity = 1;
    let triggerStepClick = false;

    if ($btn.closest('.product-block.sample-pack-addtocart').length) {
        quantity = $('.sample-of-packs .product__quantity .js-qty__wrapper .js-qty__num').val() || 1;
        triggerStepClick = true;
    }
    if($(this).parents().hasClass('sunkissed_sticky-cart')){
      quantity = $('#productModalqty .qty-input-custom .js-qty__num').val() || 1;
      triggerStepClick = true;
    }
    addToCart(sampleid, quantity, $btn, triggerStepClick);
});


  if($('body').hasClass('newdesign')){
      function setStep(step) {
      const fill = document.getElementById('cv4-step-progressFill');
      const stepWidth = 50;
      let scale_value =  step - 1
      if(scale_value===3){
       fill.style.width = `${(2) * stepWidth}%`;
      }else{
       fill.style.width = `${(scale_value) * stepWidth}%`;
      }
      
      for (let i = 1; i <= 4; i++) {
        const circle = document.getElementById('cv4-step-circle' + i);
        circle.classList.remove('cv4-step-completed');
        circle.innerHTML = i;
        if (i <= step) {
          circle.classList.add('cv4-step-completed');
          circle.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0876/4706/0152/files/tick-vs.png?v=1745468903" alt="✓">`;
        }
      }
    }
  }else{
    function setStep(step) {
      const fill = document.getElementById('cv4-step-progressFill');
      const stepWidth = 50;
      fill.style.width = `${(step - 1) * stepWidth}%`;
      for (let i = 1; i <= 3; i++) {
        const circle = document.getElementById('cv4-step-circle' + i);
        circle.classList.remove('cv4-step-completed');
        circle.innerHTML = i;
        if (i <= step) {
          circle.classList.add('cv4-step-completed');
          circle.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0876/4706/0152/files/tick-vs.png?v=1745468903" alt="✓">`;
        }
      }
    }
  }


/* sunkissed dune */
 function sunkissedoverlay(){
    if($("#jkoverlay").length)
    {
      $("#jkoverlay").show();
    }
    else
    {
    var overlay = $('<div id="jkoverlay"> </div>');
    overlay.appendTo(document.body)
    }
  }  
  function sunkissedhideoverlay(){
    $("#jkoverlay").hide();
      $('#whychoosedune').removeAttr('open')
  } 

 $(document).on('click',".sample_whychoose",function(){
    var varianttt = $(this).parents('.main-color-guide').find('.selected_products').html() || '';
   if(varianttt.trim() == 'Wall Scrub'){
     var finalVariant = 'Wall Scrub';
       selectedVariant = 'Wall Scrub';   
   }else{
     var finalVariant = varianttt.trim().split(' ');
       selectedVariant = finalVariant.length > 1 ? finalVariant[1] : finalVariant[0];   
   }
    
    $('.whychoosedune').removeClass('display_block');
    $('.whychoosedune[data-thumb="'+selectedVariant+'"]').addClass('display_block');
    $('.whychoosedune[data-thumb="'+selectedVariant+'"]').css('display:block');

    $("#whychoosedune").attr("open","");
    sunkissedoverlay();

    if(!$(".whychthumbwrap").hasClass("slick-initialized"))
    {
    $('.whychthumbwrap').slick({
      dots: false,
      slidesToShow:4,
      slidesToScroll: 1,
      arrows: false,
      asNavFor: '.whychimagewrap',
      focusOnSelect: true,
       infinite:true,
      responsive: [
                        {
                          breakpoint: 768,
                          settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            infinite:true,
                          }
                        }
                      ]
    });
    }

    if(!$(".whychimagewrap").hasClass("slick-initialized")){
    $('.whychimagewrap').slick({
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: true,
      asNavFor: '.whychthumbwrap',
      infinite: true,
     prevArrow: `
      <button type="button" class="slick-prev pull-left" aria-label="Previous">
        <svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 6 9 12 15 18" />
        </svg>
      </button>
    `,
    nextArrow: `
      <button type="button" class="slick-next pull-right" aria-label="Next">
        <svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 6 15 12 9 18" />
        </svg>
      </button>
    `,


      responsive: [
                        {
                          breakpoint: 768,
                          settings: {    
                            slidesToShow: 1,
                            arrows:true,
                          }
                        }
                      ]  
    });
    }
   setTimeout(function(){
      $('.whychthumbwrap').slick('refresh');
    $('.whychimagewrap').slick('refresh');
   },500);
   
     $('html, body').animate({
      scrollTop: $('body').offset().top
    }, 10);
  });

//popup video play and pause on button click
document.addEventListener('DOMContentLoaded', () => {
    const videos = document.querySelectorAll('.sunkissed-video');

    videos.forEach(video => {
        const container = video.closest('.video-container-snkissed');
        const playButton = container.querySelector('.play-button');

        video.muted = true;

        function togglePlay() {
            if (video.paused) {
                video.play();
                playButton.style.display = 'none';
            } else {
                video.pause();
                playButton.style.display = 'flex';
            }
        }

        playButton.addEventListener('click', togglePlay);

        video.addEventListener('play', () => {
            playButton.style.display = 'none';
        });

        video.addEventListener('pause', () => {
            playButton.style.display = 'flex';
        });
    });
});

$(".het_Products").on("click", function(){
  $('.select_the_pro_modal').addClass('open-select-modal');
  sunkissedoverlay();
  
  collectieslider();
  
});

$(document).on('click','.cross_the_pro_modal img',function(){
  $(this).parents('.select_the_pro_modal_qty').removeClass('open-select-modal');
  $(this).parents('.select_the_pro_modal').removeClass('open-select-modal');
  sunkissedhideoverlay();
});

$(".sunkissed_sticky_hoeveelheid").on("click", function(){
   $('.overlay_for_popup').addClass('addoverlay');
   $('.select_the_pro_modal_qty').addClass('open-select-modal');
});


$(document).on('click','.sample_complete_look_slider .variant-name-option button',function(){
    $(this).addClass('activeeq')
    $('.sample_complete_look_slider .variant-name-option button:not(.activeeq)+ul').removeClass('show_vrnts_ul');
    $(this).removeClass('activeeq')
    $(this).siblings('ul').toggleClass('show_vrnts_ul');
})



$(document).on('click','li.sunkissed-variants.sunkissed-variants-show',function(){
   if ($('body').hasClass('ctm-summer_dune')) {
      return; // ❌ Stop execution
  }
  let orgPrice = $(this).find('img').data('original-price');
  let discPrice = $(this).find('img').data('discounted-price');
  let originalPrice = parseFloat($(this).find('img').data('original-price'));
  let discountedPrice = parseFloat($(this).find('img').data('discounted-price'));
  let comparePrice = parseFloat($(this).find('img').data('compare-price'));

    if (isNaN(originalPrice)) originalPrice = 0;
    if (isNaN(discountedPrice)) discountedPrice = 0;
    if (isNaN(comparePrice)) comparePrice = 0;
    $('.pdp-total .act-price').text('€' + originalPrice.toFixed(0).replace('.', ','));
    $('.pdp-total .act-price').attr('data-cmpare-price','€' + originalPrice.toFixed(0).replace('.', ','));
    if (comparePrice == 0) {
        $('.pdp-total .disc-price').text('');
    }else{
      $('.pdp-total .disc-price').text('€' + comparePrice + ',-');
    $('.pdp-total .disc-price').attr('data-cmpare-price','€' + comparePrice.toFixed(0).replace('.', ','));
    }
  
// Update disc-price only if there’s a discount
if (discountedPrice < originalPrice) {
    $('.pdp-total .disc-price').text('€' + discountedPrice.toFixed(0).replace('.', ','));
    $('.pdp-total .disc-price').attr('data-disc-price','€' + discountedPrice.toFixed(0).replace('.', ','));
    // $('.pdp-total .act-price').addClass('line_thorugh');
} else {
    // $('.pdp-total .disc-price').text(''); 
    // $('.pdp-total .act-price').removeClass('line_thorugh');
}
   $(this).siblings().removeClass('checked_variant');
   $(this).addClass('checked_variant');
   var vrntidd = $(this).attr('variantid');
   var  vrntprice = $(this).attr('vrnt-price');
   var qtty = $(this).attr('qtys');
    if ($('body').hasClass('color_template_sunkissed')) {
     $('.color_template_sunkissed .color_guide_email .product-block.sample-pack-addtocart button').attr('sampleid',vrntidd);
    }else{
    $('.product-block.sample-pack-addtocart button').attr('sampleid',vrntidd);
    }
    $('.sunkissed-dune.sample-of-packs .inspired_add_to_cart').attr('sampleid',vrntidd);
    $('.sunkissed-dune.sample-of-packs .inspired_add_to_cart b').text(vrntprice);
    $('.product-block.sample-pack-addtocart button').prop('disabled', false);
    $('.sunkissed-dune.sample-of-packs .cv4-step-step:nth-child(3)').click();
    $('.product-block.sample-pack-addtocart span.product__pricess').text(vrntprice);
    
    if (window.matchMedia("(min-width: 768px)").matches) {
      changesprice($('.product__quantity input').val());
    }else{
      changesprice($('.select_the_pro_modal_qty .product__quantity input').val());
    }
     if (qtty > 0) {
         $(".color_template_sunkissed .product-block.sample-pack-addtocart").removeAttr('style');
         $(".color_template_sunkissed .product-block.sample-pack-addtocart .button-texter").text("IN MIJN WINKELMAND");
          $(".color_template_sunkissed .product-block.sample-pack-addtocart .qty-button-flex").css({"pointer-events": "unset","opacity": "unset"});
         $(".color_template_sunkissed .product-block.sample-pack-addtocart .pro-prices").removeAttr('style');
      } else {
         $(".color_template_sunkissed .product-block.sample-pack-addtocart .button-texter").text("Out of Stock");
         $(".color_template_sunkissed .product-block.sample-pack-addtocart .qty-button-flex").css({"pointer-events": "none","opacity": "0.8"});
         $(".color_template_sunkissed .product-block.sample-pack-addtocart .pro-prices").css('display:none');
      }
   changesvrntliter();
      $('.color_template_sunkissed .select_the_pro_modal_qty .select_qty_add_product').css({
        'opacity': 'unset', // or any number between 0 and 1
        'pointer-events': 'unset'
    });
});


$(document).on('click','li.sunkissed-variants.sunkissed-variants-show',function(){

  if (!$('body').hasClass('ctm-summer_dune')) {
      return; // ❌ Stop execution
  }

  let orgPrice = $(this).find('img').data('original-price');
  let discPrice = $(this).find('img').data('discounted-price');
  let originalPrice = parseFloat(orgPrice);
  let discountedPrice = parseFloat(discPrice);

  

  if (isNaN(originalPrice)) originalPrice = 0;
  if (isNaN(discountedPrice)) discountedPrice = 0;
  
  $('.pdp-total .act-price').text('€' + originalPrice.toFixed(0).replace('.', ','));
    $('.pdp-total .act-price').attr('data-cmpare-price','€' + originalPrice.toFixed(0).replace('.', ','));
    $('.pdp-total .act-price').text('€' + originalPrice.toFixed(0).replace('.', ','));
    $('.pdp-total .act-price').attr('data-cmpare-price','€' + originalPrice.toFixed(0).replace('.', ','));
  
  // Update discount price
  if (discountedPrice < originalPrice) {
      $('.pdp-total .disc-price').text('€' + discPrice);
      $('.pdp-total .disc-price').attr('data-disc-price','€' + discPrice);
      // $('.pdp-total .act-price').addClass('line_thorugh');
  } else {
      $('.pdp-total .disc-price').text('');
      // $('.pdp-total .act-price').removeClass('line_thorugh');
  }

  $(this).siblings().removeClass('checked_variant');
  $(this).addClass('checked_variant');

  var vrntidd = $(this).attr('variantid');
  var vrntprice = $(this).attr('vrnt-price');
  var qtty = $(this).attr('qtys');

  if ($('body').hasClass('color_template_sunkissed')) {
      $('.color_template_sunkissed .color_guide_email .product-block.sample-pack-addtocart button').attr('sampleid',vrntidd);
  } else {
      $('.product-block.sample-pack-addtocart button').attr('sampleid',vrntidd);
  }

  $('.sunkissed-dune.sample-of-packs .inspired_add_to_cart').attr('sampleid',vrntidd);
  $('.sunkissed-dune.sample-of-packs .inspired_add_to_cart b').text(vrntprice);
  $('.product-block.sample-pack-addtocart button').prop('disabled', false);
  $('.sunkissed-dune.sample-of-packs .cv4-step-step:nth-child(3)').click();
  $('.product-block.sample-pack-addtocart span.product__pricess').text(vrntprice);

  if (window.matchMedia("(min-width: 768px)").matches) {
      changesprice($('.product__quantity input').val());
  } else {
      changesprice($('.select_the_pro_modal_qty .product__quantity input').val());
  }

  if (qtty > 0) {
      $(".color_template_sunkissed .product-block.sample-pack-addtocart").removeAttr('style');
      $(".color_template_sunkissed .product-block.sample-pack-addtocart .button-texter").text("IN MIJN WINKELMAND");
      $(".color_template_sunkissed .product-block.sample-pack-addtocart .qty-button-flex").css({"pointer-events": "unset","opacity": "unset"});
      $(".color_template_sunkissed .product-block.sample-pack-addtocart .pro-prices").removeAttr('style');
  } else {
      $(".color_template_sunkissed .product-block.sample-pack-addtocart .button-texter").text("Out of Stock");
      $(".color_template_sunkissed .product-block.sample-pack-addtocart .qty-button-flex").css({"pointer-events": "none","opacity": "0.8"});
      $(".color_template_sunkissed .product-block.sample-pack-addtocart .pro-prices").css('display:none');
  }

  changesvrntliter();
  $('.color_template_sunkissed .select_the_pro_modal_qty .select_qty_add_product').css({
      'opacity': 'unset',
      'pointer-events': 'unset'
  });

});



$('.select-het-pro').click(function(){  
  if(window.innerWidth > 767){
    $('.sunkissed-dune-muurverf .select_the_pro_modal_info').addClass('overlays_het_pro');
    $('.sunkissed-dune-muurverf .sunkissed_dune_drawer').css('left','0');
  } else{
    $('.sunkissed_for_mobile').toggle();
    $('.list-of-select-pro').toggle();
    if($('.sunkissed_dune_product-form.sunkissed_for_mobile').is(':visible') === true){
        $('.select_the_pro_modal').addClass('inc_heightt')
    }else{
        $('.select_the_pro_modal').removeClass('inc_heightt')
    }
  }
    
});

$('.cross_sunkissed_dune_drawer').click(function(){
   $('.sunkissed_dune_drawer').css('left','-100%');
   $('.select_the_pro_modal_info').removeClass('overlays_het_pro');
});

$(document).on('click','.sunkissed_dune_radio-option',async function(){
    var selectedhet = $(this).find('.sunkissed_dune_option_heading').text();
    var value = $(this).attr('sunkissedpro');
    $('.list-of-select-pro .muurverf-vrnt-slider').removeClass('muurverf-collectie_slider');
      $('.list-of-select-pro .muurverf-vrnt-slider[muurverf-collectie="' + selectedhet + '"]').addClass('muurverf-collectie_slider'); //.find('input[type="radio"]').first().click();

      if(selectedhet == 'Lakverf'){
        $('#pc-primer-shower div span').text('lakprimer');
        $('#pc-paint-shower div span').text('lakverf');
        $('.sample_complete_slider .muren-slide').css('display','block');
      }else if(selectedhet == 'Lakprimer'){
         $('#pc-primer-shower div span').text('lakprimer');
        $('#pc-paint-shower div span').text('lakverf');
        $('.sample_complete_slider .muren-slide').css('display','block');
      }
       else if(selectedhet == 'Muurprimer'){
         $('#pc-primer-shower div span').text('muurprimer');
         $('#pc-paint-shower div span').text('muurverf');
         $('.sample_complete_slider .muren-slide').css('display','block');
      }
       else if(selectedhet == 'Wall Scrub'){
          $('#pc-primer-shower div span').text('muurprimer');
          $('#pc-paint-shower div span').text('wall scrub');
         $('.sample_complete_slider .muren-slide').css('display','none');
       }else{
          $('#pc-primer-shower div span').text('muurprimer');
          $('#pc-paint-shower div span').text('muurverf');
         $('.sample_complete_slider .muren-slide').css('display','none');
       }
  
    $('.select_the_pro_modal_info').removeClass('overlays_het_pro');
    $('.list-of-select-pro').show();
    if($('.sunkissed_dune_product-form.sunkissed_for_mobile').is(':visible') === true){
        $('.select_the_pro_modal').addClass('inc_heightt')
    }else{
        $('.select_the_pro_modal').removeClass('inc_heightt')
    }

      collectieslider();
    
  
  const muurverfdata = await sunkissedproduct(value);
  window.variant = muurverfdata;
  window.currentvariantt = muurverfdata.productType;
  window.onlyLakPrimer = muurverfdata.title;
 

  var checkedval = $('.muurverf-collectie_slider .variant-select-modal input').val();
  var firstprice = "€" + parseFloat(muurverfdata.variants.nodes[0].price.amount).toFixed(2).replace('.', ',');
  $('.product-block.sample-pack-addtocart span.product__pricess').text(firstprice);

   /* variants changes*/     
      $('.sample_varnt_picker ul').empty();
      $('.sunkissed-dune .variants-loop').empty();
  
      $('.main_thumb.slick-slide.slick-current.slick-active img.pro-main-img').attr('src', '');
      $('.guide_thumb.slick-slide.slick-current.slick-active img.pro-main-img').attr('src', '');
      var newSrc = muurverfdata.variants.nodes[0].image.url;
      $('.main_thumb.slick-slide.slick-current.slick-active img.pro-main-img').attr('src', newSrc);
      $('.guide_thumb.slick-slide.slick-current.slick-active img.pro-main-img').attr('src', newSrc);
  
      let calc_loopvrnt = [];
  window.muurverfdataa = muurverfdata;
      // --- Discount data parsing ---
const discountDataRaw = JSON.parse(document.getElementById('discount-data').textContent);
const discountData = discountDataRaw.map(line => {
  if (line.includes('=>')) {
    const [left, right] = line.split('=>').map(s => s.trim());
    const parts = left.split(' ');
    return {
      brand: parts[0].toLowerCase(),
      part1: parts[1] ? parts[1].toLowerCase().replace(/[\s\/-]/g,'') : '',
      part2: parts[2] ? parts[2].toLowerCase().replace(/[\s\/-]/g,'') : '',
      discount: Number(right)
    };
  }
  return null;
}).filter(Boolean);

window.discountData = discountData;

// --- Loop through variants ---
muurverfdata.variants.nodes.forEach((varntt) => { 
  var vv = varntt.title.split('/ ').pop();
  var litr = varntt.title.split(' / ')[0];
  var vrntprice = "€" + parseFloat(varntt.price.amount).toFixed(2).replace('.', ',');
  var calvrntprice = parseFloat(varntt.price.amount) * 100;
  const gid = varntt.id;
  const id = gid.split('/').pop();
  const varnt_img = varntt.image.url;

  // --- Active class ---
  var active_class = '';
  if(vv === checkedval || ['Muurprimer','Lakprimer','Wall Scrub'].includes(checkedval)){
    active_class = 'sunkissed-variants-show';
  }

  // --- Availability text ---
  if (varntt.quantityAvailable > 0) {
    $(".color_template_sunkissed .product-block.sample-pack-addtocart .button-texter").text("IN MIJN WINKELMAND");
  } else {
    $(".color_template_sunkissed .product-block.sample-pack-addtocart .button-texter").text("Out of Stock");
  }

  // --- Price calculations ---
  const originalPrice = parseFloat(varntt.price.amount);
  const comparePrice = parseFloat(varntt.compareAtPrice?.amount);
  const cleanPrice = originalPrice;
  let discountedPrice = cleanPrice;
  let appliedDiscount = 0;

  const productTitleClean = muurverfdata.title.toLowerCase().replace(/[\s\/-]/g,'');
  const variantTitleClean = varntt.title.toLowerCase().replace(/[\s\/-]/g,'');

  discountData.forEach(d => {
    const part1Clean = d.part1;
    const part2Clean = d.part2;
    if (productTitleClean.includes(d.brand) &&
        variantTitleClean.includes(part1Clean) &&
        (part2Clean === '' || variantTitleClean.includes(part2Clean))) {
      discountedPrice = cleanPrice - d.discount;
      appliedDiscount = d.discount;
    }
  });

  // --- Build <li> ---
  const sunkissed_vrnt = `
    <li class="tst2 ddd sunkissed-variants ${active_class}" 
        variantid="${id}" 
        title="${varntt.title}" 
        sunkissed-vrnt="${vv}" 
        vrnt-price="${vrntprice}" 
        singleprice="${calvrntprice}" 
        qtys="${varntt.quantityAvailable}">
      <img src="${varnt_img}" 
           alt="" 
           data-original-price="${originalPrice}" 
           data-clean-price="${cleanPrice}" 
           data-compare-price="${comparePrice}"
           data-discounted-price="${discountedPrice}" 
           data-discount="${appliedDiscount}" />
      ${litr}
    </li>
  `;
  $('.sample_varnt_picker ul').append(sunkissed_vrnt);    

  // --- CAL LOOP ---
  calc_loopvrnt.push(`
    <div class="varntsnamme" 
         variantid="${id}" 
         fullname="${varntt.title}" 
         litre="${litr}" 
         variant-name="${vv}" 
         price="${calvrntprice}" 
         original-price="${originalPrice}" 
         clean-price="${cleanPrice}" 
         discounted-price="${discountedPrice}" 
         discount="${appliedDiscount}">
      ${varntt.title}
    </div>
  `);
});

// --- Calculator product variants ---
muurverfdata?.calculator_product?.reference?.variants?.nodes.forEach((item) => {
  let pricess = parseFloat(item.price.amount) * 100;
  let fullname = muurverfdata.productType == 'Wall Scrub' 
                 ? `${item.title} / test` 
                 : item.title;

  const originalPrice = parseFloat(item.price.amount);
  const cleanPrice = originalPrice;
  let discountedPrice = cleanPrice;
  let appliedDiscount = 0;

  const productTitleClean = muurverfdata.title.toLowerCase().replace(/[\s\/-]/g,'');
  const variantTitleClean = item.title.toLowerCase().replace(/[\s\/-]/g,'');

  discountData.forEach(d => {
    const part1Clean = d.part1;
    const part2Clean = d.part2;
    if (productTitleClean.includes(d.brand) &&
        variantTitleClean.includes(part1Clean) &&
        (part2Clean === '' || variantTitleClean.includes(part2Clean))) {
      discountedPrice = cleanPrice - d.discount;
      appliedDiscount = d.discount;
    }
  });

  calc_loopvrnt.push(`
    <div class="varntsnamme s" 
         variantid="${item.id.split('/').pop()}" 
         fullname="${fullname}" 
         litre="${item.title}" 
         variant-name="${item.title}" 
         price="${pricess}" 
         original-price="${originalPrice}" 
         clean-price="${cleanPrice}" 
         discounted-price="${discountedPrice}" 
         discount="${appliedDiscount}">
      ${item.title}
    </div>
  `);
});

$('.sunkissed-dune.sample-of-packs .variants-loop').append(calc_loopvrnt);

        
        muurverfdata?.calculator_product?.reference?.variants?.nodes.forEach((item)=>{
         let pricess = parseFloat(item.price.amount) * 100;
          let fullname = muurverfdata.productType == 'Wall Scrub' 
          ? `${item.title} / test` 
          : item.title;
           calc_loopvrnt.push( ` <div class="varntsnamme s" variantid="${item.id.split('/').pop()}" fullname="${fullname}"  litre="${item.title}" variant-name="${item.title}" price="${pricess}"> ${item.title}</div> `)        
        });
        $('.sunkissed-dune.sample-of-packs .variants-loop').append(calc_loopvrnt);

  /* end variant changes */

  

  $('.sunkissed-dune.sample-of-packs .samples_bought_slider').empty();

muurverfdataa?.sample_colorcards?.references?.nodes.forEach((item) => {
  console.log(item,'itemmmmm')
    let handle = item.handle;
    if (handle === 'verfrollers-voor-muurverf' && item.variants?.nodes?.length > 0 || handle === 'softgrip-beugel-voor-rollers-1' && item.variants?.nodes?.length > 0 ) {
      item.variants.nodes.forEach((variant) => {
            let price = variant.price.amount.replace('.', ',');
            let img = item.featuredImage?.url || '';
            let rawTitle = item.title;   
             if (rawTitle === 'Softgrip Beugel voor Rollers') {
                  rawTitle = 'Beugel';
              } else if (rawTitle === 'Verfrollers voor muurverf') {
                  rawTitle = 'Muurverf roller';
              }
            let title = `${rawTitle} - ${variant.title}`;
            let gid = variant.id;
            let id = gid.split('/').pop();            
            let html = `
                <div class="samples_pro ttttt">
                    <div class="sample_product_img">
                        <a href="${handle}"><img src="${img}" alt="" style="padding:0;"></a>
                    </div>
                    <div class="sample_product_title">${title}</div>
                    <div class="sample_product_price">€${price}</div>
                    <div class="adding-cart" sampleid="${id}">Voeg toe aan winkelmand</div>
                </div>
            `;
            $('.sunkissed-dune.sample-of-packs .samples_bought_slider').append(html);
        });
    } else {
        let price = item.priceRange.minVariantPrice.amount.replace('.', ',');
        let img = item.featuredImage?.url || '';
        let title = item.title;
        let gid = item.variants.nodes[0].id;
        let id = gid.split('/').pop();

        let html = `
            <div class="samples_pro">
                <div class="sample_product_img">
                    <a href="${handle}"><img src="${img}" alt="" style="padding:0;"></a>
                </div>
                <div class="sample_product_title">${title}</div>
                <div class="sample_product_price">€${price}</div>
                <div class="adding-cart" sampleid="${id}">Voeg toe aan winkelmand</div>
            </div>
        `;
        $('.sunkissed-dune.sample-of-packs .samples_bought_slider').append(html);
    }

    $('.sunkissed-dune.sample-of-packs .samples_bought_slider').slick('refresh');
});


});

function collectieslider(){
  if (window.matchMedia("(max-width: 700px)").matches) {
    if($('.muurverf-collectie_slider .vrnt-input-radios-slider').length > 1){
      if($('.muurverf-collectie_slider').hasClass('slick-initialized')){
        $('.muurverf-collectie_slider').slick('refresh')
      }else{
        $('.muurverf-collectie_slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      dots:true,
       responsive: [
                         {
                           breakpoint: 767,
                           settings: {
                             slidesToShow: 1,
                             arrows: false,
                               dots:true,
                           }
                         }
                       ]
  });
        $('.muurverf-collectie_slider[muurverf-collectie="Muurverf"]').slick('slickGoTo', 1);
      }     
    }  
}
}




async function sunkissedproduct(value) {
  const myHeaders = new Headers();
  myHeaders.append("X-Shopify-Storefront-Access-Token", "a41953cfa79e4018ebd12ab597aac14c");
  myHeaders.append("Content-Type", "application/json");

  const query = {
    query: `
      {
        productByHandle(handle: "${value}") {
          id
          title
          productType
          featuredImage {
            url
          }
          variants(first: 200) {
            nodes {
              image {
                url
              }
              title
              id
              quantityAvailable
              price {
                amount
                currencyCode
              }
              compareAtPrice{
                amount
                currencyCode
              }
            }
          }
          images(first: 20) {
            nodes {
              url
            }
          }
          calculator_product: metafield(namespace: "custom", key: "calculator_product") {
            value
            reference {
              ... on Product {
                id
                title                          
                variants(first: 200) {
                  nodes {
                    image {
                      url
                    }
                    title
                    id
                    price {
                      amount
                      currencyCode 
                    }
                  }
                }
              }
            }
          }   
            collection_25: metafield(namespace: "custom", key: "collection_25") {
            value
            reference {
              ... on Collection {
                id
                title
                products(first: 50) {
                  nodes {
                    id
                    title
                    variants(first: 10) {
                      nodes {
                        id
                        title
                        price {
                          amount
                          currencyCode
                        }
                        image {
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          }    
          sunkissed_btn_banner:metafield(namespace: "custom", key: "sunkissed_btn_banner") {
                     value
                    reference {
                        ... on MediaImage {
                        image {
                            url        
                        }
                        }
                    }
                }
           Color_perfection:metafield(namespace: "custom", key: "new_field") {
                     value                 
                }         
          sample_colorcards: metafield(namespace: "custom", key: "sample_colorcards"){
               value
              references(first: 20) {
                nodes {
                  ... on Product {
                    id
                    title
                    handle
                    featuredImage {
                      url
                    }
                    priceRange {
                      minVariantPrice {
                        amount
                        currencyCode
                      }
                    }
                    variants(first: 200) {
                      nodes {
                        image {
                          url
                        }
                        title
                        id
                        price {
                          amount
                          currencyCode 
                        }
                      }
                    }
                  }
                }
              }
          }
        }
      }
    `
  };

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(query),
    redirect: "follow"
  };

  try {
    const response = await fetch("https://shades-by-eric-kuster.myshopify.com/api/2024-10/graphql.json", requestOptions);
    const result = await response.json();
    return result.data.productByHandle;
  } catch (error) {
    console.error(error);
    return null;
  }
}

$('.sample_complete_look_slider li.collectie-btns.show_varnt_meta').click(function(){
    var dataid = $(this).data('id');
    $(this).parents('.variant-name-option').find('.adding-cart').attr('sampleid',dataid);
   $(this).parent('ul').removeClass('show_vrnts_ul');
   var vrntnames = $(this).text();
  $(this).parents('.mps-slide-for-product-selector').find('button span.select-varintss').text(vrntnames);
});

$(document).on('click', '.sunkissed-variants', function () {
  $('.cross_the_pro_modal').trigger('click');
});

$(document).on('click','.select_qty_add_product',function(){
  if ($('body').hasClass('color_template_sunkissed')) {
   var vrntids = $(this).parents('.select_the_pro_modal_info').find('.sample_varnt_picker li.checked_variant').attr('variantid');
   var qttyys = $(this).parents('.select_the_pro_modal_qty').find('.qty-input-custom input.js-qty__num').val();
    $.ajax({
              url: "/cart/add.js",
              type: "post",
              data: { id: vrntids, quantity: qttyys },
              success: function (productt) {
                  document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                      detail: {
                          product: productt
                      }
                  }));
                  $('.cv4-step-step:nth-child(4)').click();
              },
              error: function () {
                  console.error("Error adding product to cart.");
              }
          });
  }else{
    $('.overlay_for_popup').removeClass('addoverlay');
    $(this).parents('.select_the_pro_modal_qty').removeClass('open-select-modal');
  }
});

$('.select_the_pro_modal_info .cross_the_pro_modal img').click(function(){
   if (!$('body').hasClass('color_template_sunkissed')) {
    $('.select_qty_add_product').click()
   }
    $('.overlay_for_popup').removeClass('addoverlay');
});

 $(document).ready(function(){
     var len = $('.sample-of-packs .color_guide-imags.for_desktop .mains-imgs .main_thumb').length;
     if(len <= 4)
     {
      var len = 3
     }else{
      var len = 4
     }
      var $sliders = $('.sample-of-packs .color_guide-imags.for_desktop .mains-imgs');
      var $thumbs = $('.sample-of-packs .color_guide-imags .color_guide_thumbs');
    var $progressBars = $('.sample-of-packs .main-color-guide .progress');
    var $progressBarLabels = $('.sample-of-packs .main-color-guide .slider__label');

    // Set initial progress bar width to 2% if it's the first slide
    $progressBars
      .css('background-size', '2% 100%')
      .attr('aria-valuenow', 2);

    $progressBarLabels.text('2% completed');

    $sliders.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var calc;

      if (nextSlide === 0) {
        // If it's the first slide, set the progress to 2%
        calc = 2;
      } else {
        // For other slides, calculate progress normally
       calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
      }

      $progressBars
        .css('background-size', calc + '% 100%')
        .attr('aria-valuenow', calc);

      $progressBarLabels.text(calc + '% completed');
    });
if($('.main_thumb').length > 1){ 
    $sliders.not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: true,
      asNavFor: $thumbs,
       responsive: [
                         {
                           breakpoint: 767,
                           settings: {
                             slidesToShow: 1,
                             arrows: false,
                           }
                         }
                       ]
  });
    $thumbs.not('.slick-initialized').slick({
      slidesToShow: len,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
    focusOnSelect: true,
      asNavFor: $sliders,
    responsive: [
                      {
                        breakpoint: 767,
                        settings: {
                        slidesToShow: len,
                        arrows: false,
                 }
           }
          ]
  }); 
}



    jQuery(function($) {
      // Custom carousel nav
      $('.sample-of-packs .color_guide-imags.for_desktop .first-sliders .prod_sec-prev').click(function() {
        $('.sample-of-packs .color_guide-imags.for_desktop .mains-imgs').slick('slickPrev');
      });

      $('.sample-of-packs .color_guide-imags.for_desktop .first-sliders .prod_sec-next').click(function(e) {
        e.preventDefault();
        $('.sample-of-packs .color_guide-imags.for_desktop .mains-imgs').slick('slickNext');
      });

    });
       
  });


/* 7 pages */
let pro_infoss = []
async function renderproduct_sec(value) {
  const myHeaders = new Headers();
  myHeaders.append("X-Shopify-Storefront-Access-Token", "a41953cfa79e4018ebd12ab597aac14c");
  myHeaders.append("Content-Type", "application/json");
  const query = {
  query: `
    {
      collections(first: 1, query: "title:'${value}'") {
        nodes {
          id
          title
          products(first: 20) {
            nodes {
              id
              title
              handle
              productType
              featuredImage {
                url
              }
              options {
                name
                values
                optionValues {
                  name
                  firstSelectableVariant {
                    image {
                      url
                    }
                  }
                }
              }
                    media(first: 20) {
              edges {
              node {
              mediaContentType
              previewImage{
               url(transform: { preferredContentType: WEBP })
              } 
               ... on Video {
            id
            sources {
            url
            mimeType
            }
           }
              }
              }
             }
              variants(first: 200) {
                nodes {
                 datasheet:metafield(namespace: "custom", key: "datasheet") {
                                    value
                  }
                  image {
                    url
                  }
                  title
                  id
                  price {
                    amount
                    currencyCode
                  }
                  compareAtPrice {
                    amount
                    currencyCode
                  }
                }
              }
              images(first: 20) {
                nodes {
                  url
                }
              }
              calculator_product: metafield(namespace: "custom", key: "calculator_product") {
                value
                reference {
                  ... on Product {
                    id
                    title
                    afwerking: metafield(namespace: "custom", key: "afwerking") {
                      value
                    }
                    dekking: metafield(namespace: "custom", key: "dekking") {
                      value
                    }
                    droogtijd: metafield(namespace: "custom", key: "droogtijd") {
                      value
                    }
                    gebruik: metafield(namespace: "custom", key: "gebruik") {
                      value
                    }
                    ondergrond_voorbehandeling: metafield(namespace: "custom", key: "ondergrond_en_voorbehandeling") {
                      value
                    }
                    algemeen_gebruik: metafield(namespace: "custom", key: "algemeen_gebruik") {
                      value
                    }
                    variants(first: 200) {
                      nodes {
                        image {
                          url
                        }
                        title
                        id
                        price {
                          amount
                          currencyCode
                        }
                      }
                    }
                  }
                }
              }
              afwerking: metafield(namespace: "custom", key: "afwerking") {
                value
              }
              dekking: metafield(namespace: "custom", key: "dekking") {
                value
              }
              droogtijd: metafield(namespace: "custom", key: "droogtijd") {
                value
              }
              gebruik: metafield(namespace: "custom", key: "gebruik") {
                value
              }
              ondergrond_voorbehandeling: metafield(namespace: "custom", key: "ondergrond_en_voorbehandeling") {
                value
              }
              algemeen_gebruik: metafield(namespace: "custom", key: "algemeen_gebruik") {
                value
              }
              sample_product: metafield(namespace: "custom", key: "sample_product") {
                value
                reference {
                  ... on Product {
                    variants(first: 1) {
                      nodes {
                        id
                        quantityAvailable
                      }
                    }
                  }
                }
              }
              mlsample_product: metafield(namespace: "custom", key: "ml_tester") {
                value
                reference {
                  ... on Product {
                    variants(first: 1) {
                      nodes {
                        id
                        quantityAvailable
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
};

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(query),
    redirect: "follow"
  };
  try {
    const response = await fetch("https://shades-by-eric-kuster.myshopify.com/api/2024-10/graphql.json", requestOptions);
    const result = await response.json();
    const products = result.data.collections?.nodes?.[0]?.products?.nodes || [];
    pro_infoss = products
    $('.Bestslller .bestseller-colors').empty();
    products.forEach((product, index) => {
      var colorValue = product.title;
      
      let firstWord = null
     var firstvl=colorValue.split(' ');
      if (colorValue.includes("Summer Dune") || colorValue.includes("Spring Dune") || colorValue.includes("Sunkissed Dune")) {     
          // if(firstvl.length===3){
     
        //  firstvl.pop();
        //  var result = firstvl.join(" ");
        console.log(firstvl,'firstvlfirstvl')
         var result = firstvl.slice(0, 2).join(" "); 
          firstWord=result  
           
        }
        else{
          firstWord = product.title.split(' ')[0];
        } 
      const productHandle = product.handle;
      const activeClass = index === 0 ? 'active-color' : '';
      let newColorDiv = '';
      product.variants.nodes.some((variant, i) => {
        var vv = variant.title.split('/ ').pop();
        let attr = $('header.section-header.title-of-page').attr('data-muurverf');
        let text = '';
        if (attr && attr.includes('Muurverf')) {
        let parts = attr.split('Muurverf');
        if (parts[1]) {
        text = parts[1].trim();
        }
        }
        
      if(text == 'Superior'){
         if (vv == text) {
        newColorDiv = `
          <div class="main-color-div tt" hide-color="${firstWord}" product-name="${colorValue}">
            <div handle="${productHandle}" tab-color="${firstWord}" class="colorss ${activeClass}"></div>
            
             <span>${firstWord}</span>
                     
          </div>`;
        $('.Bestslller .bestseller-colors').append(newColorDiv);
         if (templateSuffix !== 'outdoor') {
  $('.Bestslller .main-color-div:first-child').click();
}
        return true;
         } 
      }else{
        
      
        newColorDiv = `
          <div class="main-color-div ccc" hide-color="${firstWord}" product-name="${colorValue}">
            <div handle="${productHandle}" tab-color="${firstWord}" class="colorss ${activeClass}"></div>
           
             <span>${firstWord}</span>
            
          </div>`;
        $('.Bestslller .bestseller-colors').append(newColorDiv);
         if (templateSuffix !== 'outdoor') {
  $('.Bestslller .main-color-div:first-child').click();
}
        return true; 
      }        
      });
    });

  } catch (error) {
    console.error('Error in renderproduct_sec:', error);
  }
}

$('.color_popup .main-color-div').click(function (params) {
  $(this).siblings().find('.colorss').removeClass('active');
  $(this).find('.colorss').addClass('active');
  const value = $(this).attr('tst');
  renderproduct_sec(value);
});

function updatTotalPrice() {
  console.log('hjjhsdch')
  var qttty = $('.muurverf-page .product__quantity .js-qty__wrapper .js-qty__num').val();
  
 
  var single_Vprice = $('.muurverf-page .pro-prices .totaal-prices').attr('pro_price'); 
  var disc_Vprice = $('.muurverf-page .pro-prices .totaal-prices').attr('prod_disc_price');


  var ttotle = single_Vprice * qttty;
  var formattedTotal = '€' + ttotle + ',-';

  var dattaprice = $('body.muurverf-page .variant-wrapper .variant-input-wrap:not([name=Kleur]) input:checked+label img').attr('data-price');
  var dataDiscprice = $('body.muurverf-page .variant-wrapper .variant-input-wrap:not([name=Kleur]) input:checked+label img').attr('data-final-price');
   var datacompprice = $('body.muurverf-page .variant-wrapper .variant-input-wrap:not([name=Kleur]) input:checked+label img').attr('data-compare-price');

  var dattapriceNum = parseFloat(dattaprice.replace(/[^0-9.]/g, ''));
  var dataDiscpriceNum = parseFloat(dataDiscprice.replace(/[^0-9.]/g, ''));
  var datacomppriceNum = parseFloat(datacompprice.replace(/[^0-9.]/g, ''));
 
  console.log(dattapriceNum,'actualprice');
  console.log(datacompprice,'compareprice')

function cleanPrice(price) {
  if (!price) return 0;
  // Remove € sign, spaces, dash, and all non-numeric characters except digits and comma/dot
  let clean = price.toString().replace(/[€\s\-]/g, '');

  // If comma is used as decimal, replace it with dot
  clean = clean.replace(',', '.');

  // Remove any leftover non-digit/dot chars
  clean = clean.replace(/[^0-9.]/g, '');

  return parseFloat(clean);
}

var dattapriceNum = cleanPrice(dattaprice);
var dataDiscpriceNum = cleanPrice(dataDiscprice);

// if (dattapriceNum !== dataDiscpriceNum && dataDiscpriceNum != 'NaN') {
// if (!isNaN(dattapriceNum) && !isNaN(dataDiscpriceNum) && dattapriceNum !== dataDiscpriceNum) {
//   $('.totaal-prices .product__price').text(dattaprice);
//   // $('.pdp-total-price .act-price').addClass('line_thorugh');
//   let dattaprice1 = '€' + parseFloat(dattaprice.replace(/[^0-9.]/g, '')).toFixed(0) + ',-';
//   $('.pdp-total-price .act-price').text(dattaprice1);
//   let formattedPrice = '€' + parseFloat(dataDiscprice.replace(/[^0-9.]/g, '')).toFixed(0) + ',-';
//   $('.pdp-total-price .disc-price').text(formattedPrice);
//   let cleanPrice = dataDiscprice.replace('€', '').trim();
//   $('.product-block--price .totaal-prices').attr('prod_disc_price', cleanPrice);
//   $('.product-block--price .totaal-prices').attr('pro_price', dattapriceNum);
//   console.log('iffffffff')
// } else {
//   console.log('datacomppriceNum',datacomppriceNum)
//   console.log('datacompprice',datacompprice)
//   $('.totaal-prices .product__price').text(dattaprice);
//   // $('.pdp-total-price .act-price').removeClass('line_thorugh');
//  }
  if (datacomppriceNum !== '' && !isNaN(datacomppriceNum)) {
    console.log('ifff')
    let formattedPrice = '€' + parseFloat(dattaprice.replace(/[^0-9.]/g, '')).toFixed(0) + ',-';
    $('.pdp-total-price .act-price').text(formattedPrice);
    $('.pdp-total-price .disc-price').text(`€${datacomppriceNum},-`);
     $('.product-block.product-block--price .totaal-prices').attr('pro_comp_price',datacomppriceNum);
     $('.product-block.product-block--price .totaal-prices').attr('pro_price',dattapriceNum);
  }else{
    console.log('else else')
    $('.product-block--price .totaal-prices').attr('pro_comp_price', '');
    $('.product-block.product-block--price .totaal-prices').attr('pro_price',dattapriceNum);
    $('.pdp-total-price .disc-price').text('');
       let formattedPrice = '€' + parseFloat(dattaprice.replace(/[^0-9.]/g, '')).toFixed(0) + ',-';
    $('.pdp-total-price .act-price').text(formattedPrice);
  }


  $(".new-products .Muurverf-addtocart .pro-prices span.product__price").text(formattedTotal);
  if($('body').hasClass('newdesign')){
  setStep(3)
  }

}
$(document).on('click','.muurverf-page .variant__button-label',function(){
      setTimeout(function(){



   var  a1 = $('body.muurverf-page .variant-wrapper .variant-input-wrap:not([name=Kleur]) input:checked + label img').attr('src');

    var variddd = $(this).find('img').attr('varidd');
    $('.inspired_add_to_cart').attr('sampleid',variddd);
    var pronme = $('.newdesign .bestseller-colors .main-color-div:has(.actice-color)').attr('product-name')
    pro_infoss.forEach((product,index) => {
        if (pronme == product.title) {
           var variants = product?.variants?.nodes;
          var vrntimage = product?.media?.edges;
           $('.new-pro_featured_images').empty();
           $('.new-pro_featured_images').removeClass('slick-initialized')
           $('.new-pro_featured_images').removeClass('slick-slider');
           $('.new_first_slider_media').empty();
           $('.new_first_slider_media').removeClass('slick-initialized')
           $('.new_first_slider_media').removeClass('slick-slider');
          const newImage = {url: a1};
          console.log(newImage,'newImage')
          const variantUrls = new Set(variants.map(v => v.image && v.image.url).filter(Boolean));
          const filteredImages = vrntimage.filter(image => !variantUrls.has(image?.node?.previewImage?.url));
          console.log(variantUrls,'variantUrlsvariantUrls')
            console.log(filteredImages,'filteredImages')
          filteredImages.push(newImage)
          filteredImages.forEach((image, index) => {
                       if(image?.node?.mediaContentType=='VIDEO'){
                          var newColorDiv = `<div class="pro_thumb" match="" data-product><img src="${image?.node?.previewImage?.url}"</div>`;
                        }if(image?.node?.mediaContentType=='IMAGE'){
                          var newColorDiv = `<div class="pro_thumb" match="" data-product><img width="" height="" loading="lazy" alt="" src="${image?.node?.previewImage?.url}"></div>`;
                        }
                      $('.new-pro_featured_images').append(newColorDiv);
                    });
             filteredImages.forEach((image, index) => {
                       if(image?.node?.mediaContentType=='VIDEO'){
                          var newColorDiv = `<div class="pro_thumb" match="" data-product><video width="100%" muted loop playsinline preload="none" poster="${image?.node?.previewImage?.url}" data-lazy style="object-fit:cover;" > <source data-src="${image?.node?.sources[1]?.url}" type="video/mp4"></video></div>`;
                        }if(image?.node?.mediaContentType=='IMAGE'){
                          var newColorDiv = `<div class="pro_thumb" match="" data-product><img width="" height="" loading="lazy" alt="" src="${image?.node?.previewImage?.url}"></div>`;
                        }
                      $('.new_first_slider_media').append(newColorDiv);
                    });
                   newmainslider()
                   videoplay()

                   $('body.newdesign .new-pro_featured_images .pro_thumb img[src="'+a1+'"]').click();
        }
    })

          var qtty = $('.muurverf-page .js-qty__wrapper .js-qty__num, .muurverf-page .product__quantity .js-qty__wrapper .js-qty__num').val();
          var vrntnme = $(this).attr('checkc');
          setTimeout(function(){
            updatTotalPrice();
            changesprice(qtty);
          },200)

   },100);
});

$(document).on('click','.Bestslller .main-color-div',function(){
  $(this).siblings().find('.colorss').removeClass('actice-color');
  $(this).find('.colorss').addClass('actice-color');
    var pronme = $(this).attr('product-name');      
    pro_infoss.forEach((product,index) => {
      const protitle = product.title;
        if (pronme == protitle) {
          window.currentvariant = product;  
          let sample_product = parseInt(window.currentvariant?.sample_product?.reference?.variants?.nodes[0].id.split('/').pop())
           let sample_product_qty = parseInt(window.currentvariant?.sample_product?.reference?.variants?.nodes[0].quantityAvailable)
          let mlsample_product = parseInt(window.currentvariant?.mlsample_product?.reference?.variants?.nodes[0].id.split('/').pop())
          let mlsample_product_qty = parseInt(window.currentvariant?.mlsample_product?.reference?.variants?.nodes[0].quantityAvailable)
          if($('body').hasClass('newdesign')){
           setStep(1)
          }
         if($('body').hasClass('muurverf-essential')){
          let idd = parseInt(window.currentvariant.variants.nodes.filter((item) => item.title.includes('Essential'))[0].id.split('/').pop())
          document.querySelectorAll(`.variants-tabs_desc .variants-metafield`).forEach((item)=>{item.classList.remove("variant-title-show")})
          if(document.querySelector(`.variants-tabs_desc .variants-metafield[varidd="${idd}"]`)){
              document.querySelector(`.variants-tabs_desc .variants-metafield[varidd="${idd}"]`).classList.add("variant-title-show");
          }
         }
           if($('body').hasClass('muurverf-superior')){
          let idd = parseInt(window.currentvariant.variants.nodes.filter((item) => item.title.includes('Superior'))[0].id.split('/').pop())
          document.querySelectorAll(`.variants-tabs_desc .variants-metafield`).forEach((item)=>{item.classList.remove("variant-title-show")})
          if(document.querySelector(`.variants-tabs_desc .variants-metafield[varidd="${idd}"]`)){
              document.querySelector(`.variants-tabs_desc .variants-metafield[varidd="${idd}"]`).classList.add("variant-title-show");
          }
         }
          
          $('.sample_dropdown button.sample-dropdown-toggle').removeClass('open-the-menu');
         $('.sample_dropdown ul.sample-dropdown-menu').hide()
         if (!sample_product_qty || sample_product_qty <= 0) {
              $('li.sample-color-card').text('Out of Stock');
              $('li.sample-color-card').addClass('disabled');
          } else {
              $('li.sample-color-card').attr('data-id', sample_product);
              $('li.sample-color-card').removeClass('disabled');
              $('li.sample-color-card').text('+ A4 kleurkaart €3,-');
          }
          
          // ML sample product check
          if (!mlsample_product_qty || mlsample_product_qty <= 0) {
              $('li.mltester-color-card').text('Out of Stock');
              $('li.mltester-color-card').addClass('disabled');
          } else {
              $('li.mltester-color-card').attr('data-id', mlsample_product);
               $('li.mltester-color-card').removeClass('disabled');
            $('li.mltester-color-card').text('+ 100ml Kleurtester Muurverf €10,-');
          }

          const varianttt = $('.section-header.title-of-page').attr('data-muurverf');
          var selectedVariant = '';
          if (varianttt && varianttt.trim() === 'wall scrub') {
             selectedVariant = '1 liter';
          } else if (varianttt.trim() === 'lakverf') {
            selectedVariant = 'Mat';
          }  else if (varianttt.trim() === 'Muurprimer') {
            selectedVariant = '4 liter';
          }
            else if (varianttt.trim() === 'lakprimer') {
            selectedVariant = '1 liter';
          }
          else {
            var finalVariant = varianttt.trim().split(' ');
            selectedVariant = finalVariant.length > 1 ? finalVariant[1] : finalVariant[0];
          }
          if (window.currentvariant.variants.nodes.length === 1) {
              var first_variant_img = window.currentvariant?.variants?.nodes[0].image.url;
          }else{
            var first_variant_img =  window.currentvariant?.variants?.nodes?.filter((item)=>item.title.includes(selectedVariant))[0].image.url;
          }          
          var vrntimage = product?.images?.nodes;
          var variants = product?.variants?.nodes;
           $('.new-pro_featured_images').empty();
           $('.new-pro_featured_images').removeClass('slick-initialized')
           $('.new-pro_featured_images').removeClass('slick-slider');
           $('.new_first_slider_media').empty();
           $('.new_first_slider_media').removeClass('slick-initialized')
           $('.new_first_slider_media').removeClass('slick-slider');
          const newImage = {
              url: first_variant_img
            };
           
          const variantUrls = new Set(variants.map(v => v.image && v.image.url).filter(Boolean));

          const filteredImages = vrntimage.filter(image => !variantUrls.has(image.url));
          filteredImages.push(newImage)
          filteredImages.forEach((image, index) => {
                      const newColorDiv = `
                        <div class="pro_thumb" match="" data-product>
                          <img width="" height="" loading="lazy" alt="" src="${image?.url}">
                        </div>`;
                      $('.new-pro_featured_images').append(newColorDiv);
                      $('.new_first_slider_media').append(newColorDiv);
                    });            
                   newmainslider()       
        }
    }); 

    $('.muurverf-page .product__quantity .js-qty__wrapper .js-qty__num').val('1')
    updatTotalPrice()

     if (!$("body").hasClass("lakverf") && !$("body").hasClass("muurprimer") && !$("body").hasClass("Lakprimer") && !$("body").hasClass("muurverf-essential")  ) {
       let attr = $('header.section-header.title-of-page').attr('data-muurverf');     
      let text = '';
      if (attr && attr.includes('Muurverf')) {
      let parts = attr.split('Muurverf');
      if (parts[1]) {
      text = parts[1].trim();
      }
      }
      let imagess = window.currentvariant.variants.nodes.filter(item => item.title.includes(text));
      let varid = parseInt(imagess[0].id.split('/').pop());
      let slec2 = document.querySelectorAll('.variant-input-wrap[data-handle="inhoud"] label img')  
        imagess.forEach((pro,index)=>{
          if(slec2[index]){
            slec2[index].setAttribute('varidd',`${pro.id.split('/').pop()}`);    
            slec2[index].setAttribute('src',pro.image.url); 
            slec2[index].setAttribute('data-original-price',pro.price.amount);
            slec2[index].setAttribute('simple-price',pro.price.amount);
            slec2[index].setAttribute('data-final-price',pro.price.amount);
            slec2[index].setAttribute('data-price',pro.price.amount);
            slec2[index].setAttribute('data-compare-price',pro.compareAtPrice?.amount);
          }
                        
        })
     }
     else if($("body").hasClass("muurverf-essential")){
        if($('body').hasClass('newdesign')){
         setStep(2)
        }

      let fulltext = '';
const variantIds = [];
const vrntP = []; // <-- keep original price here
const vrntimg = [];


// --- Get discount data from HTML JSON ---
const discountDataRaw = JSON.parse(document.getElementById('discount-data').textContent);
const discountData = discountDataRaw.map(line => {
  if (line.includes('=>')) {
    const [left, right] = line.split('=>').map(s => s.trim());
    const parts = left.split(' ');
    return {
      brand: parts[0].toLowerCase(),
      part1: parts[1] ? parts[1].toLowerCase().replace(/[\s\/-]/g,'') : '',
      part2: parts[2] ? parts[2].toLowerCase().replace(/[\s\/-]/g,'') : '',
      discount: Number(right)
    };
  }
  return null;
}).filter(Boolean);

// --- Filter variants containing "Essential" ---
window.currentvariant.variants.nodes.filter(item => item.title.includes("Essential")).forEach((varntt, index) => {
    const variantId = varntt.id.split('/').pop();
    variantIds.push(variantId);
    vrntimg.push(varntt.image.url);
    // --- Calculate discount ---
    const productTitleClean = window.currentvariant.title.toLowerCase().replace(/[\s\/-]/g,'');
    const variantTitleClean = varntt.title.toLowerCase().replace(/[\s\/-]/g,'');
    let variantDiscount = 0;

    discountData.forEach(d => {
      if (productTitleClean.includes(d.brand) &&
          variantTitleClean.includes(d.part1) &&
          variantTitleClean.includes(d.part2)) {
        variantDiscount = d.discount;
      }
    });

    const originalPrice = varntt.price.amount; 
     const compareprice = varntt.compareAtPrice?.amount; 
    const cleanPrice = originalPrice.replace(',', '');
    const discountedPrice = Number(cleanPrice) - Number(variantDiscount); 
    vrntP.push(originalPrice); 

    let variant_tittlee  = varntt.title.split('/')[0].trim()
    fulltext += `
      <div class="variant-input" data-index="option2" data-value="${variant_tittlee}">
        <input type="radio"
          form="AddToCartForm-template--24896040042876__new_main_product_f6ymxV-8144196239663"
          value="${variant_tittlee}"
          data-index="option2"
          name="Afwerking"
          data-variant-input=""
          id="ProductSelect-${variantId}">
        <label for="ProductSelect-${variantId}" class="variant__button-label" checkc="${variant_tittlee}" tab-color="">
          <img src="${vrntimg[index]}"
            alt="${variant_tittlee}"
            varidd="${variantId}"
            variss="${variant_tittlee}"
            data-variant-name="${window.currentvariant.title}===${variant_tittlee}"
            data-compare-price="€${compareprice}"
            data-original-price="€${originalPrice}"
            data-discount="€${variantDiscount}"
            data-final-price="€${discountedPrice}"
            data-price="€${parseInt(vrntP[index])},-" 
            simple-price="${parseInt(vrntP[index])}">
          <span colorlakverf="${window.currentvariant.title.split(' ')[0]}" class="lakverf-colors 2641"></span>
          <span>${variant_tittlee}</span>
        </label>
      </div>
    `;
  });

// --- Insert into DOM ---
document.querySelector("body.muurverf-essential fieldset[name='Inhoud']").innerHTML = fulltext;


}
  else if($("body").hasClass("muurprimer")){
      let fulltext = '';
const variantIds = [];
const vrntP = [];
const comparedprices = [];
const vrntimg = [];

// --- Get discount data from HTML JSON ---
const discountDataRaw = JSON.parse(document.getElementById('discount-data').textContent);
const discountData = discountDataRaw.map(line => {
  if (line.includes('=>')) {
    const [left, right] = line.split('=>').map(s => s.trim());
    const parts = left.split(' ');
    return {
      brand: parts[0].toLowerCase(),
      part1: parts[1] ? parts[1].toLowerCase().replace(/[\s\/-]/g,'') : '',
      part2: parts[2] ? parts[2].toLowerCase().replace(/[\s\/-]/g,'') : '',
      discount: Number(right)
    };
  }
  return null;
}).filter(Boolean);


// --- Collect variants and prices ---
window.currentvariant.variants.nodes.forEach((varntt) => {
  const vrntidd = varntt.id.split('/').pop();
  const vrntp = varntt.price.amount * 100 / 100;
  const compareprice = varntt.compareAtPrice?.amount * 100 / 100;
  variantIds.push(vrntidd);
  vrntP.push(vrntp);
  comparedprices.push(compareprice);
  vrntimg.push(varntt.image.url);
});

// --- Build HTML for “Inhoud” option ---
let change = window.currentvariant.options.filter((item) => item.name.includes('Inhoud'));

change[0].optionValues.forEach((item, index) => {
  const variantName = item.name;
  const productTitleClean = window.currentvariant.title.toLowerCase().replace(/[\s\/-]/g,'');
  const variantTitleClean = variantName.toLowerCase().replace(/[\s\/-]/g,'');

  // --- Find matching discount ---
  let variantDiscount = 0;
  discountData.forEach(d => {
    if (productTitleClean.includes(d.brand) &&
        variantTitleClean.includes(d.part1) &&
        variantTitleClean.includes(d.part2)) {
      variantDiscount = d.discount;
    }
  });

  const originalPrice = vrntP[index];
  const compareoriginalprice = comparedprices[index];
  const discountedPrice = originalPrice - variantDiscount;

  fulltext += `
    <div class="variant-input" data-index="option2" data-value="${variantName}">
      <input type="radio"
        form="AddToCartForm-template--24896040042876__new_main_product_f6ymxV-8144196239663"
        value="${variantName}"
        data-index="option2"
        name="Afwerking"
        data-variant-input=""
        class=""
        id="ProductSelect-template--24896040042876__new_main_product_f6ymxV-8144196239663-option-afwerking-${variantName}">
      <label for="ProductSelect-template--24896040042876__new_main_product_f6ymxV-8144196239663-option-afwerking-${variantName}"
        class="variant__button-label"
        checkc="${variantName}"
        tab-color=""> 
        <img src="${vrntimg[index]}"
          alt="${variantName}"
          varidd="${variantIds[index]}"
          variss="${variantName}"
          data-compare-price="${compareoriginalprice}"
          data-original-price="€${originalPrice}"
          data-discount="€${variantDiscount}"
          data-final-price="€${discountedPrice}"
          data-price="€${parseInt(originalPrice)},-"
          simple-price="${parseInt(originalPrice)}">
        <span colorlakverf="${window.currentvariant.title.split(' ')[0]}" class="lakverf-colors"></span> 
        <span>${variantName}</span>
      </label>
    </div>
  `;
});

document.querySelector("body.muurprimer fieldset[name='Inhoud']").innerHTML = fulltext;
     
     }
       else if($("body").hasClass("Lakprimer")){
       let fulltext = ''
       const variantIds = [];
       const vrntP = [];
       const comparedprices = [];

      window.currentvariant.variants.nodes.forEach((varntt) => {
        const vrntidd = varntt.id.split('/').pop();
           const vrntp = varntt.price.amount * 100 / 100;
           const compareprice = varntt.compareAtPrice?.amount * 100 / 100;
        variantIds.push(vrntidd);
         vrntP.push(vrntp);
         comparedprices.push(compareprice);
      });

      let change = window.currentvariant.options.filter((item)=>item.name.includes('Inhoud'))     
    $('body.muurverf-page.Lakprimer .variant-wrapper .variant-input-wrap .variant-input img').each(function(ind){
      console.log(change[0],'change[0]')
     const originalPrice = vrntP[ind];
     const compareoriginalprice = comparedprices[ind];
    const vridd = variantIds[ind]
    $(this).attr('src', change[0].optionValues[ind].firstSelectableVariant.image.url);

    console.log('originalPrice bbbbb',originalPrice)
     $(this).attr('data-original-price',originalPrice);
     $(this).attr('simple-price',originalPrice);
     $(this).attr('data-final-price',originalPrice);
     $(this).attr('data-price',originalPrice);
     $(this).attr('data-compare-price',compareoriginalprice);
     $(this).attr('varidd',vridd);

});   
     }
     else{
      let fulltext = ''
      let change = window.currentvariant.options.filter((item)=>item.name.includes('Afwerking'))
      let datasetarry = window.currentvariant.variants.nodes.map((item) =>{ return { dataset: item.datasheet?.value, title: item.title.split('/').pop()?.trim() }; });

      change[0].optionValues.forEach((item,index)=>{    
          let dset = datasetarry.find(itemss => itemss.title === item.name && itemss.dataset);
       fulltext += `<div class="variant-input" data-index="option2" data-value="${item.name}" ttt>
       <input type="radio" form="AddToCartForm-template--24896040042876__new_main_product_f6ymxV-8144196239663" value="${item.name}" data-index="option2" name="Afwerking" data-variant-input="" class="" id="ProductSelect-template--24896040042876__new_main_product_f6ymxV-8144196239663-option-afwerking-${item.name}" ${index===0 ?'checked=""':'' }>
       <label data-set="${dset?.dataset}" mat="" for="ProductSelect-template--24896040042876__new_main_product_f6ymxV-8144196239663-option-afwerking-${item.name}" class="variant__button-label" checkc="${item.name}" tab-color=""> <span colorlakverf="${window.currentvariant.title.split(' ')[0]}" class="lakverf-colors 2792"></span> <span>${item.name}</span> </label></div>`
      })
      document.querySelector("body.lakverf fieldset[name='Afwerking']").innerHTML = fulltext;       
      let jsss = window.currentvariant.options.find(opt => opt.name === "Inhoud")?.values || [];
      document.querySelectorAll(`body.lakverf .variant-input-wrap[data-handle="inhoud"] label`).forEach((item, index) => {
      const checkValue = jsss[index];      
      if (item.getAttribute("checkc") === checkValue) {
      item.classList.remove("Deactivate");
      } else {
      item.classList.add("Deactivate");
      }
      });

      let imagess = window.currentvariant.variants.nodes.filter(item => item.title.includes('1 liter'));
      let varid = parseInt(imagess[0].id.split('/').pop());
      let imagess22 = window.currentvariant.variants.nodes.filter(item => item.title.includes('2.5 liter'));
      let varid22 = parseInt(imagess22[0].id.split('/').pop());
      let slec2 = document.querySelectorAll('.variant-input-wrap[data-handle="inhoud"] .variant-input[data-value="1 liter"] label img')
      let slec3 = document.querySelectorAll('.variant-input-wrap[data-handle="inhoud"] .variant-input[data-value="2.5 liter"] label img')
      imagess22.forEach((pro,index)=>{
          if(slec3[index]){
             slec3[index].setAttribute('varidd',`${pro.id.split('/').pop()}`);    
             slec3[index].setAttribute('src',pro.image.url);  
             slec3[index].setAttribute('data-original-price',pro.price.amount);
            slec3[index].setAttribute('simple-price',pro.price.amount);
            slec3[index].setAttribute('data-final-price',pro.price.amount);
            slec3[index].setAttribute('data-price',pro.price.amount);
            slec3[index].setAttribute('data-compare-price',pro.compareAtPrice?.amount); 
          }                     
        })
      imagess.forEach((pro,index)=>{
          if(slec2[index]){
             slec2[index].setAttribute('varidd',`${pro.id.split('/').pop()}`);    
             slec2[index].setAttribute('src',pro.image.url);   
            slec2[index].setAttribute('data-original-price',pro.price.amount);
            slec2[index].setAttribute('simple-price',pro.price.amount);
            slec2[index].setAttribute('data-final-price',pro.price.amount);
            slec2[index].setAttribute('data-price',pro.price.amount);
            slec2[index].setAttribute('data-compare-price',pro.compareAtPrice?.amount);
          }                     
      })

     }         
      
     if($('body').hasClass('muurprimer')){
       $('.variant-wrapper[data-option="Inhoud"] .variant-input:nth-child(1) label').click()  
     }
     else if($('body').hasClass('muurverf-essential')){
      $('.variant-wrapper[data-option="Inhoud"] .variant-input:nth-child(1) label').click()  
     }
       else{
          $('.variant-wrapper[data-option="Inhoud"] .variant-input:nth-child(2) label').click()  
       }

       $('html, body').scrollTop(0);
      
    const secarry = window.currentvariant?.variants?.nodes ?? [];
    const checkcc = window.currentvariant?.calculator_product?.reference?.variants?.nodes ?? [];
    const combined = checkcc.concat(secarry); 
    const varaint_loop = document.querySelectorAll('.variants-loop .varntsnamme')
    function returnId(fullname) {
    const match = combined.find(item => item.title === fullname);
    if (match) {
      return match.id;
    } else {
      return null; 
    }
    }
    
    if(varaint_loop){
    varaint_loop.forEach((item, index) => {
      const fullname = item.getAttribute('fullname');
      const value = returnId(fullname)
      const variantId = parseInt(value?.split('/')?.pop())
        if (Number.isNaN(variantId)) {
        }else{
            item.setAttribute('variantid',variantId);
        }
      });
    }
  


    });

$(document).on('click','.Muurverf-addtocart button.add-to-cart',function () {      
    if($('body').hasClass('newdesign')){
  setStep(4)
  }      
    let addvarnt = [];
    let id = null
    if(!$('body').hasClass('lakverf') && !$('body').hasClass('Lakprimer')){
      id = parseInt($('.variant-input-wrap[data-handle="inhoud"] input:checked+label img').attr('varidd'));
    }
    else{
     const nesss = Array.from(document.querySelectorAll('.variant-input-wrap input:checked + label')).map(label => label.getAttribute('checkc'));
     let formet_id =  window.currentvariant.variants.nodes.find(variant =>nesss.every(selected => variant.title.includes(selected)));
      id = parseInt(formet_id.id.split('/').pop())
    }
    let quantity = parseInt($('input[name="quantity"]').val())
    if (id && quantity) {
      addvarnt.push({
          id: id,
          quantity: quantity
      });
    }
    if (addvarnt.length > 0) {
    fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: addvarnt })
    })
    .then(response => response.json())
    .then(data => {
      console.log("Success:", data);
      Rebuy.SmartCart.show();
    })
    .catch(error => console.error("Error:", error));
    }
});

$(document).ready(function() {
  (async () => {
    const v_l = $('.color_popup .main-color-div:has(.active)').attr('tst') || 'beige muurverf';
    await renderproduct_sec(v_l);    

      if (templateSuffix !== 'outdoor') {
  $('.Bestslller .main-color-div:first-child').click();
}
  })();  
});

$(document).on('click','body.muurverf-page.muurprimer .variant-wrapper .variant-input-wrap:not([name=Kleur]) .variant-input,body.muurverf-page.Lakprimer .variant-wrapper .variant-input-wrap:not([name=Kleur]) .variant-input,body.muurverf-essential .variant-wrapper .variant-input-wrap:not([name=Kleur]) .variant-input',function(){
   var dattaprice = $(this).find('img').attr('data-price');
   var simpleprice = $(this).find('img').attr('simple-price');
    var imgsrc = $(this).find('img').attr('src');
  var ltrr = $(this).attr('data-value');
    $('.totaal-prices .product__price').text(dattaprice);    
  $('.muurverf-page .pro-prices .totaal-prices').attr('pro_price',simpleprice)
   $('.muurverf-page .variant-tab .variants-metafield .varnt-tab-headng span').text(ltrr);
});
$(document).on('click','body.lakverf .variant-wrapper.variant-wrapper--custom--button.js[data-option=Afwerking] input+label.variant__button-label',function(){
    var pdff = $(this).attr('data-set');
    var optiname = $(this).attr('checkc');
    var litr = $('.variant-wrapper .variant-input-wrap:not([name=Kleur]) input:checked+label').attr('checkc');
   $('.muurverf-page .variants-metafield a.download-datasheet').attr('href',pdff);
    $('.muurverf-page .variant-tab .variants-metafield .varnt-tab-headng span').text(litr+' / '+optiname);

    $('.newdesign .popup_for_alles_het_pro').removeClass('open_the_het_products');
    $('.newdesign .popup_for_alles_het_pro[popup_variant='+optiname+']').addClass('open_the_het_products');
    $('.newdesign .color_guide_bg').addClass('alles_het_popup');

    $('.variant-input-wrap[name="Inhoud"] .variant-input img').each(function () {
    var cc = $(this).attr('varissecond').trim()
        if (cc === optiname) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
});
/* project pages*/


/* projectsets */

/* end projectsets */

window.addEventListener("scroll", function () {
    const element = document.querySelector("body"); // Element jisko class add karni hai
      // Check for mobile screen width
      if (window.innerWidth <= 768) { // Mobile screen size
      

        if (window.scrollY > 600) {
          element.classList.add("muurverf_sticky");
        } else {
          element.classList.remove("muurverf_sticky");
        }
      }

        if (window.scrollY > 52) {
          element.classList.add("header_sticky");
        } else {
          element.classList.remove("header_sticky");
        }

    });


function updateBodyOverflow() {
  if ($('#NavDrawer').hasClass('drawer--is-open')) {
    $('body').css('overflow', 'hidden');
  } else {
    $('body').css('overflow', '');
  }
}
$('.site-nav__link--icon').on('click', function() {
 $('.color_guide_bg').css('display', 'block');
  updateBodyOverflow();
});

$('.drawer__close-button,.color_guide_bg').click(function(){
   $('body').css('overflow', '');
})

$(document).on('click', function(event) {
      if (!$(event.target).closest('#NavDrawer').length) {
        $('body').css('overflow', '');
      }
    });





$(document).off('click', '.variant-select-modal').on('click', '.variant-select-modal', function() {
 $('.cross_the_pro_modal img').click();
 if (document.body.classList.contains("color_template_sunkissed")) {
    $(".not_wallscrub .color_guide_thumbs").slick('unslick');
    $(".not_wallscrub .mains-imgs").slick('unslick');
    $(".not_wallscrub .color_guide_thumbs").html('');
    $(".not_wallscrub .mains-imgs").html('');

         window.muurverfdataa.images.nodes.forEach((featuredimg,index) => {
         let extraDiv = "";
          if (index === 0) {
            extraDiv = ` <div class="truspilot_on_image" {{ forloop.index }}>
                    <img src="https://cdn.shopify.com/s/files/1/0731/9388/1903/files/Productpage_Sunkissed_Dune_-_a4_sample_1_c36c94fe-b9f1-4af2-8d51-1ffd396e6511.png?v=1748234232" width="" height="" loading="lazy">
                  </div> 
                  <div class="pro_name_on_img">
                     <div class="name-of-product">${window.muurverfdataa.title.split(' ')[0]}</div>
                   <div class="color-of-product">${window.muurverfdataa.Color_perfection.value}</div>
                  </div>
                  <div class="why_choose_position">
                    <div class="sample_whychoose">Waarom <span class="sample_whychoose-spans">${window.muurverfdataa.title.split(' ')[0]}</span></div>
                  </div>
                  `;
          }
          mainthumbs = `
            <div class="main_thumb" ${index}>
              <img class="pro-main-img" 
                  src="${featuredimg.url}" 
                  alt="SHADES by Eric Kuster" 
                  width="" 
                  height="" 
                  loading="lazy">
                  ${extraDiv}
            </div>`;
          thumbs = `
            <div class="guide_thumb">
              <img class="pro-main-img" 
                  src="${featuredimg.url}" 
                  alt="SHADES by Eric Kuster" 
                  width="" 
                  height="" 
                  loading="lazy">
            </div>`;
            $(".not_wallscrub .color_guide_thumbs").append(thumbs);           
            $(".not_wallscrub .mains-imgs").append(mainthumbs);
           
          });
           var $sliders = $('.color_template_sunkissed .not_wallscrub .mains-imgs');
            var $thumbs = $('.color_template_sunkissed .not_wallscrub .color_guide_thumbs');
            $sliders.not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            asNavFor: $thumbs,
            responsive: [
                              {
                                breakpoint: 767,
                                settings: {
                                  slidesToShow: 1,
                                  arrows: false,
                                }
                              }
                            ]
            });
            $thumbs.not('.slick-initialized').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            focusOnSelect: true,
            asNavFor: $sliders,
            responsive: [
                          {
                            breakpoint: 767,
                            settings: {
                            slidesToShow: 4,
                            arrows: false,
                      }
                }
              ]
            });
             const el = document.querySelector('.desktop-shds-txts');
              el.textContent = el.textContent.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
              const ell = document.querySelector('.color-of-product');
              ell.textContent = ell.textContent.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
      
    }

   var vall = $(this).find('input').val(); 
  var datasheet = $(this).parent('.vrnt-input-radios-slider').attr('data-sheet');
   $('.sample_techniq_sheet a').attr('href',datasheet);
   $('.color_temp_variant_tabs a.download-datasheet').attr('href',datasheet);
  var collect_val = $(this).parents('.muurverf-collectie_slider').attr('muurverf-collectie').toLowerCase();
  $('.color_template_sunkissed.sample-of-packs .sample_varnt_picker').show();
   $('.color_template_sunkissed.sample-of-packs .samples_Calculator').css({display: 'flex',});
   $('.color_template_sunkissed .color_template_varint_tab .color_temp_variant_tabs').show();
  if(collect_val != 'muurprimer' && collect_val != 'lakprimer' && collect_val != 'wall scrub'){
    
    if(collect_val == 'lakverf'){
      var exist = false;
      $(`.sample_complete_look_slider .collectie-btns.${collect_val}`).each(function(){
        if($(this).attr('matchingvrnt') == vall){
          $(this).parents('.sample_complete_look_slider').find(`.${collect_val}`).removeClass('show_varnt_meta');
          $(this).parents('.sample_complete_look_slider').find(`.${collect_val}[matchingvrnt="${vall}"]`).addClass('show_varnt_meta');
        }
      })
      
    }else{
      $(`.sample_complete_look_slider .${collect_val}`).removeClass('show_varnt_meta')
      $(`.sample_complete_look_slider .${collect_val}[matchingvrnt="${vall}"]`).addClass('show_varnt_meta')

      $(`.color_template_sunkissed .sample_complete_look_slider`).each(function(){
       var firstvrntid = $(this).find(`.${collect_val}[matchingvrnt="${vall}"]`).attr('data-id');
       $(this).find('.adding-cart').attr('sampleid',firstvrntid);
         });

    }
  }
    
if($(this).parents('.muurverf-collectie_slider').attr('muurverf-collectie')=='Muurverf'){
    $('.selected_products').text('Muurverf '+vall);
    $('.sample_varint-name').text('Muurverf '+vall);
    $('.sample_varint-name').text('Muurverf');
    $('.sample_whychoose-span').text(' Muurverf '+vall);
    $('.sunkissed_sticky-cart .het_Products span').text('Muurverf ' +vall);
    $('.sunkissed_sticky-cart .het_Products span').css('font-weight', 'bold');
    $('nav.breadcrumb.for-mob-desk .highlight').text('Muurverf ' +vall);
   $('body.sunkissed-dune.sample-of-packs #whychoosedune .dialoghead span').text('Muurverf ' +vall);
   $('.sunkissed_sticky-cart .het_Products').addClass('border-font-bold');
   $('.All_over_product span.sample_over_het-spans').text('Muurverf ' +vall);
   $('.All_over_product').attr('alles_poup',vall);
  } else if($(this).parents('.muurverf-collectie_slider').attr('muurverf-collectie')=='Lakverf'){
     $('.selected_products').text('Lakverf '+vall);
    $('.sample_varint-name').text('Lakverf '+vall);
    $('.sample_whychoose-span').text(' Lakverf '+vall);
    $('.sunkissed_sticky-cart .het_Products span').text('Lakverf ' +vall);
    $('.sunkissed_sticky-cart .het_Products span').css('font-weight', 'bold');
    $('nav.breadcrumb.for-mob-desk .highlight').text('Lakverf ' +vall);
  $('body.sunkissed-dune.sample-of-packs #whychoosedune .dialoghead span').text('Lakverf ' +vall);
   $('.All_over_product span.sample_over_het-spans').text('Lakverf ' +vall);
  $('.All_over_product').attr('alles_poup',vall);
  }
  else {
    $('.selected_products').text(vall);
    $('.sample_varint-name').text(vall);
    $('.sample_whychoose-span').text(" "+vall);
     $('.sunkissed_sticky-cart .het_Products span').text(vall);
     $('.sunkissed_sticky-cart .het_Products span').css('font-weight', 'bold');
      $('nav.breadcrumb.for-mob-desk .highlight').text(vall);
    $('body.sunkissed-dune.sample-of-packs #whychoosedune .dialoghead span').text(vall);
    $('.All_over_product span.sample_over_het-spans').text(vall);
    $('.All_over_product').attr('alles_poup',vall);
  }
  
  
       if ($('body').hasClass('color_template_sunkissed')) {
      var slugMap = {
  "Classic": "muurverf-classic",
  "Essential": "muurverf-essential",
  "Superior": "muurverf-superior",
  "Mat": "lakverf-mat",
  "Hoogglans": "lakverf-hoogglans",
  "Zijdeglans": "lakverf-zijdeglans",
  "Wall Scrub": "wallscrub",
  "Muurprimer": "muurprimer",
  "Lakprimer": "lakprimer"
};

if (slugMap[vall]) {
  var currentUrl = window.location.href;
  var parts = currentUrl.split('/');
  var prodIndex = parts.indexOf("products");

  if (prodIndex > -1 && parts.length > prodIndex + 2) {
    parts.pop();
  }

  var baseUrl = parts.join('/');
  var newUrl = baseUrl + "/" + slugMap[vall];

  if (currentUrl !== newUrl) {
    window.history.pushState({}, '', newUrl);
  }
}
       }



  var vrntimg = $(this).find('.variant-select-modal_image img').attr('src');
  $('.sunkissed-dune.sample-of-packs .mains-imgs .main_thumb.slick-slide[data-slick-index="0"] img.pro-main-img').attr('src',vrntimg);
  $('.sunkissed-dune.sample-of-packs .guide_thumb.slick-slide[data-slick-index="0"] img.pro-main-img').attr('src',vrntimg);
  if(window.fromUrl){
    window.fromUrl = false;
  }else{
    $('.sunkissed-dune.sample-of-packs .cv4-step-step:nth-child(2)').click();
  }
  if (!$('body').hasClass('color_template_sunkissed')) {
    $('.product-block.sample-pack-addtocart button').prop('disabled', true);
  }
  if(collect_val != 'muurprimer' && collect_val != 'lakprimer' && collect_val != 'wall scrub'){
    $('.sunkissed-dune.sample-of-packs .sample_varnt_picker ul li.sunkissed-variants').removeClass('sunkissed-variants-show');
    $('.sunkissed-dune.sample-of-packs .sample_varnt_picker ul li.sunkissed-variants[sunkissed-vrnt="'+vall+'"]').addClass('sunkissed-variants-show');
  }
   var value = $(this).attr('sunkissedpro');
 
  
});

 if ($('body').hasClass('color_template_sunkissed')) {
$(document).ready(function(){
  var lastWord = window.location.href.split('/').pop().split('-').pop();
    if(lastWord.toLowerCase() === "wallscrub"){
      lastWord = "Wall Scrub";
    } else {
      lastWord = lastWord.charAt(0).toUpperCase() + lastWord.slice(1);
    }
var prourl = $('.variant-select-modal input[type="radio"][value="'+lastWord+'"]').parent().attr('sunkissedpro');
$('.sunkissed_dune_radio-option[sunkissedpro="'+prourl+'"]').click();
setTimeout(function(){
$('.variant-select-modal input[type="radio"][value="'+lastWord+'"]').parent().click();
},2500)
});
 }

if ($('body').hasClass('sunkissed-dune-muurverf')) {
var lasturl = window.location.href.split('/');
var last = lasturl.pop().split('?')[0];

 if (last.includes('-dune-muurverf') || last.includes('dune-2') || last.includes('dune-muurverf') ) {
  if(last==='dune-2'){
    var last="sunkissed-dune-muur-primer"
  }
  $('.sunkissed_dune_radio-option[sunkissedpro="'+last+'"]').click();
  setTimeout(function() {
  $('.muurverf-vrnt-slider[muurverf-collectie="Muurverf"] .vrnt-input-radios-slider:nth-child(2) .variant-select-modal input[type="radio"][value="Essential"]').parent().trigger('click');
    $('.sunkissed-dune.sample-of-packs .cv4-step-step:nth-child(2) .cv4-step-circle').text("1");
  $('.sunkissed-dune.sample-of-packs .cv4-step-step:nth-child(2) .cv4-step-circle').removeClass("cv4-step-completed"); 
  }, 3000);

}else{
  $('.sunkissed_dune_radio-option[sunkissedpro="'+last+'"]').click();
  setTimeout(function(){
  $('.variant-select-modal input[type="radio"][value="'+last+'"]').parent().click();
  },2500);
 }
}

$(document).ready(function(){
  if (window.location.href == 'https://shadesbyerickuster.com/products/kleuradvies'){
    window.location.href = 'https://shadesbyerickuster.com/pages/kleuradvies'
}
});


$(document).on('click','.newdesign .all_het_product',function(){
    $('body.newdesign .popup_for_alles_het_pro[popup_variant="Classic"]').addClass('open_the_het_products');
    $('body.newdesign .popup_for_alles_het_pro[popup_variant="Mat"]').addClass('open_the_het_products');
    $('.color_guide_bg').addClass('alles_het_popup');
});
$(document).on('click','.newdesign .open_the_het_products img.cross_alles',function(){
    $(this).parent().removeClass('open_the_het_products');
    $('.color_guide_bg').removeClass('alles_het_popup');
});
$(document).on('click','.newdesign .color_guide_bg.alles_het_popup',function(){
    $(this).removeClass('alles_het_popup');
    $('.popup_for_alles_het_pro').removeClass('open_the_het_products');
});


/*js */

function newmainslider(){
  console.log(templateSuffix,'templateSuffix')
var $sliders = $('.newdesign .new_first_slider_media');
      var $thumbs = $('.newdesign .new-pro_featured_images');
    var $progressBars = $('.newdesign .thumb_featured-img .progress');
    var $progressBarLabels = $('.newdesign .thumb_featured-img .slider__label');

    // Set initial progress bar width to 2% if it's the first slide
    var thumbsToShow = (templateSuffix === 'outdoor') ? 3 : 4;

    $progressBars
      .css('background-size', '2% 100%')
      .attr('aria-valuenow', 2);

    $progressBarLabels.text('2% completed');

    $sliders.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var calc;

      if (nextSlide === 0) {
        // If it's the first slide, set the progress to 2%
        calc = 2;
      } else {
        // For other slides, calculate progress normally
       calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
      }

      $progressBars
        .css('background-size', calc + '% 100%')
        .attr('aria-valuenow', calc);

      $progressBarLabels.text(calc + '% completed');
    });

  $sliders.not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: true,
      asNavFor: $thumbs // Corrected property name
  });

  $thumbs.not('.slick-initialized').slick({
      slidesToShow: thumbsToShow,
      slidesToScroll: 1,
      arrows: false,
      infinite: true,
    focusOnSelect: true,
      asNavFor: $sliders // Corrected property name
  });


    jQuery(function($) {
      // Custom carousel nav
      $('.newdesign .new-first-slider .prod_sec-prev').click(function() {
        $('.new-first-slider .new_first_slider_media').slick('slickPrev');
         if (window.matchMedia("(max-width: 700px)").matches) {
           $('body.newdesign .new-first-slider .truspilot_on_image').hide();
        $('body.newdesign .new-first-slider .pro_name_on_img').hide();
        $('body.newdesign .new-first-slider .all_het_product').hide();
       var srrcc = $('body.muurverf-page .variant-wrapper .variant-input-wrap:not([name=Kleur]) input:checked + label img').attr('src');
        var allIndexes = [];
        $('.new-product-first-img .pro_thumb img').each(function() {
            if ($(this).attr('src') === srrcc) {
                var idx = $(this).closest('.pro_thumb').data('slick-index');
                allIndexes.push(idx);
            }
        });
      allIndexes.forEach(function(slickind) {
          $('body.newdesign .new-first-slider:has(.pro_thumb.slick-active[data-slick-index="' + slickind + '"]) .truspilot_on_image').show();
          $('body.newdesign .new-first-slider:has(.pro_thumb.slick-active[data-slick-index="' + slickind + '"]) .pro_name_on_img').show();
          $('body.newdesign .new-first-slider:has(.pro_thumb.slick-active[data-slick-index="' + slickind + '"]) .all_het_product').css('display', 'flex');
      });
     }
  });

      $('.newdesign  .new-first-slider .prod_sec-next').click(function(e) {
        e.preventDefault();
         $('.new-first-slider .new_first_slider_media').slick('slickNext');
          if (window.matchMedia("(max-width: 700px)").matches) {
         $('body.newdesign .new-first-slider .truspilot_on_image').hide();
        $('body.newdesign .new-first-slider .pro_name_on_img').hide();
        $('body.newdesign .new-first-slider .all_het_product').hide();
         var srrcc = $('body.muurverf-page .variant-wrapper .variant-input-wrap:not([name=Kleur]) input:checked + label img').attr('src');
        var allIndexes = [];
        $('.new-product-first-img .pro_thumb img').each(function() {
            if ($(this).attr('src') === srrcc) {
                var idx = $(this).closest('.pro_thumb').data('slick-index');
                allIndexes.push(idx);
            }
        });
      allIndexes.forEach(function(slickind) {
          $('body.newdesign .new-first-slider:has(.pro_thumb.slick-active[data-slick-index="' + slickind + '"]) .truspilot_on_image').show();
          $('body.newdesign .new-first-slider:has(.pro_thumb.slick-active[data-slick-index="' + slickind + '"]) .pro_name_on_img').show();
          $('body.newdesign .new-first-slider:has(.pro_thumb.slick-active[data-slick-index="' + slickind + '"]) .all_het_product').css('display', 'flex');
      });
          }
      });

    });

}
 
$(document).ready(function(){
   newmainslider()

   setTimeout(function(){
    var hrff = window.location.href;
var hrfsplit = hrff.split('=')[1];
if (hrfsplit) {
        hrfsplit = hrfsplit.charAt(0).toUpperCase() + hrfsplit.slice(1).toLowerCase();
    }
$('body.muurverf-page.new-products .variant-input-wrap[name="Afwerking"] .variant-input input[value="'+hrfsplit+'"]')
  .prop('checked', true);
   },2000)
});


$('.samples_Calculator.typeform-block .pluss_calc').click(function(){
    $('.samples_Calculator.typeform-block .sample_calculator_popup button').click();
});








/* outdoor */
var outdoorValidationFeedbackActive = false;

function outdoorSelectionGroupComplete($group) {
  var $radioInputs = $group.find('input[type=radio]');

  if ($radioInputs.length) {
    var $availableInputs = $group.find('label.active input[type=radio]');

    // Some groups (such as Product) do not use the active class.
    if (!$availableInputs.length) {
      $availableInputs = $radioInputs;
    }

    return $availableInputs.filter(':checked').length > 0;
  }

  // The rendered colour group uses an active swatch instead of radio inputs.
  return $group.find('.colorss.actice-color').length > 0;
}

function validateOutdoorSelections(showFeedback) {
  var allGroupsComplete = true;

  $('.ctm-outdoor [data-outdoor-selection-group]').each(function () {
    var $group = $(this);
    var groupComplete = outdoorSelectionGroupComplete($group);

    $group.toggleClass('outdoor-selection-incomplete', showFeedback && !groupComplete);

    if (!groupComplete) {
      allGroupsComplete = false;
    }
  });

  return allGroupsComplete;
}

function clearOutdoorValidationFeedback() {
  outdoorValidationFeedbackActive = false;
  $('.ctm-outdoor [data-outdoor-selection-group]').removeClass('outdoor-selection-incomplete');
  setOutdoorAddToCartError(false);
}

function outdoorSelectionsComplete() {
  return validateOutdoorSelections(outdoorValidationFeedbackActive);
}

function setOutdoorAddToCartError(showError) {
  $('.ctm-outdoor .outdoor-add-to-cart-error').prop('hidden', !showError);
}

$('.ctm-outdoor .Muurverf-addtocart button.add-to-cart').click(function (event) {
  outdoorValidationFeedbackActive = true;

  if (!validateOutdoorSelections(true)) {
    event.preventDefault();
    event.stopPropagation();
    setOutdoorAddToCartError(true);
    return false;
  }

  clearOutdoorValidationFeedback();
  setStep(4);

  var values = [];

  $('.ctm-outdoor .product-option-outdoor input[type=radio]:checked').each(function() {
      values.push($(this).val());
  });

  var variantId = null; // ✅ yaha define karo

  $('.outdoor-variant-name').each(function() {
      var opt1 = $(this).attr('option1');
      var opt2 = $(this).attr('option2');
      var opt3 = $(this).attr('option3');

      if (
          (values[0] == opt1 || !opt1) &&
          (values[1] == opt2 || !opt2) &&
          (values[2] == opt3 || !opt3)
      ) {
          variantId = $(this).attr('outdoor-id');
          return false; // ✅ loop break (important)
      }
  });
      
  let addvarnt = [];
  let quantity = parseInt($('input[name="quantity"]').val());

  if (variantId && quantity) {
      addvarnt.push({
          id: variantId,
          quantity: quantity
      });
  }

  if (addvarnt.length > 0) {
      fetch('/cart/add.js', {
          method: "POST",
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: addvarnt })
      })
      .then(response => response.json())
      .then(data => {
        console.log("Success:", data);
        Rebuy.SmartCart.show();
      })
      // .then(data => console.log("Success:", data))
      .catch(error => console.error("Error:", error));
  }
});

$(document).ready(function(){
  setTimeout(function(){
    setStep(3)
    if($('body').hasClass('ctm-outdoor')){
    $('.cv4-step-step:nth-child(5) div#cv4-step-circle4').text('3');
  }
  },1600)
})

/************************* */
function addToCartHandler() {
    var values = [];
    $('.ctm-outdoor .product-option-outdoor input[type=radio]:checked').each(function() {
        values.push($(this).val());
    });

      if (outdoorSelectionsComplete()) {
          $('.ctm-outdoor .muurverfpage_addtocart').removeClass('btn-deactivate');
          clearOutdoorValidationFeedback();
      } else {
          $('.ctm-outdoor .muurverfpage_addtocart').addClass('btn-deactivate');
          if (outdoorValidationFeedbackActive) {
              setOutdoorAddToCartError(true);
          }
      }

    var variantId = null;
    var price = null;
    var comparePrice = null;
    var totalPrice = 0;

    $('.outdoor-variant-name').each(function() {
        var opt1 = $(this).attr('option1');
        var opt2 = $(this).attr('option2');
        var opt3 = $(this).attr('option3');

        if (
            (values[0] == opt1 || !opt1) &&
            (values[1] == opt2 || !opt2) &&
            (values[2] == opt3 || !opt3)
        ) {
            variantId = $(this).attr('outdoor-id');
            var currencysym = $(this).parent('.hidden-outdoor-variants').attr('currency-symbol');

            price = cleanPrice($(this).attr('data-price'));
            console.log(price,'priceprice')

            comparePrice = cleanPrice($(this).attr('data-comp-price'));
            console.log(comparePrice,'comparePricecomparePrice')
            
            var qty = parseInt($('.outdoor-input-box').val()) || 1;
            
            var totalPrice = price * qty;
            var totalComparePrice = comparePrice * qty;

            $(this).parents('.page-content--product').find('.act-price').text(currencysym + totalPrice + ',-');
            
            if (comparePrice){
              $(this).parents('.page-content--product').find('.disc-price').text(currencysym + totalComparePrice  + ',-');
            }else{
              $(this).parents('.page-content--product').find('.disc-price').text('');
            }

            return false;
        }
    }); 
    
    
}

function cleanPrice(val) {
    if (!val) return 0;

    return parseFloat(
        val.toString()
           .replace(/[^\d.,]/g, '') 
           .replace(',', '.')      
    ) || 0;
}

addToCartHandler();

$(document).on('change', '.ctm-outdoor [data-outdoor-selection-group] input[type="radio"]', function(){
    if ($(this).closest('.product-option-outdoor.Product').length) {
        clearOutdoorValidationFeedback();
    }

    addToCartHandler();
});

$(document).on('click', '.ctm-outdoor [data-outdoor-selection-group] .main-color-div', function(){
    setTimeout(addToCartHandler, 0);
});

$(".outdoor-plus").click(function () {
  let $input = $(".outdoor-input-box");
  let value = parseInt($input.val()) || 0;
  let max = parseInt($input.attr("max")) || Infinity;

  if (value < max) {
    $input.val(value + 1);
    addToCartHandler();  
  }

});

$(".outdoor-minus").click(function () {
  let $input = $(".outdoor-input-box");
  let value = parseInt($input.val()) || 0;
  let min = parseInt($input.attr("min")) || 0;

  if (value > min) {
    $input.val(value - 1);
    addToCartHandler();  
  }
});



function handleOptions(vall){

    var option2Arr = [];
    var option3Arr = [];

    $('.outdoor-variant-name[option1="'+vall+'"]').each(function(){

        var opt2 = $(this).attr('option2');
        var opt3 = $(this).attr('option3');

        if(!option2Arr.includes(opt2)){
            option2Arr.push(opt2);
        }

        if(!option3Arr.includes(opt3)){
            option3Arr.push(opt3);
        }

    });

    console.log("Option2:", option2Arr);
    console.log("Option3:", option3Arr);

    // OPTION 2
    $('.Inhoud input').each(function(){
        var val = $(this).val();

        if(option2Arr.includes(val)){
            $(this).closest('.option-item').addClass('active').show();
        } else {
            $(this).closest('.option-item').removeClass('active').hide();
        }
    });

    // OPTION 3
    $('.Afwerking input').each(function(){
        var val = $(this).val();
        if(option3Arr.includes(val)){
            $(this).closest('.option-item').addClass('active').show();
        } else {
            $(this).closest('.option-item').removeClass('active').hide();
        }
    });

  $('.Afwerking input').change(function(){
        var sheet = $(this).parent().attr('datasheet');
        $('.ctm-outdoor .download-datasheet').attr('href',sheet);

    var verbruik = $(this).parent().attr('verbruik');
    var afwasbaarheid_outdoor = $(this).parent().attr('afwasbaarheid_outdoor');
    var eigenschap_outdoor = $(this).parent().attr('eigenschap_outdoor');
    var afwerking_outdoor = $(this).parent().attr('afwerking_outdoor');
    var toepassing_outdoor = $(this).parent().attr('toepassing_outdoor');

    $('.verbruik_outdoor').text(verbruik);
    $('.afwasbaarheid_outdoor').text(afwasbaarheid_outdoor);
    $('.eigenschap_outdoor').text(eigenschap_outdoor);
    $('.afwerking_outdoor').text(afwerking_outdoor);
    $('.toepassing_outdoor').text(toepassing_outdoor);
     });

}

$('.product-option-outdoor.Product label.option-item').click(function(){
    var vall = $(this).find('input').val();
    var sheet = $(this).attr('datasheet');
    handleOptions(vall);
    $('label.option-item.mat_hided input').prop('checked', true);
    $('.outdoor-pro').text(vall);
    $('.ctm-outdoor .download-datasheet').attr('href',sheet);

    var verbruik = $(this).attr('verbruik');
    var afwasbaarheid_outdoor = $(this).attr('afwasbaarheid_outdoor');
    var eigenschap_outdoor = $(this).attr('eigenschap_outdoor');
    var afwerking_outdoor = $(this).attr('afwerking_outdoor');
    var toepassing_outdoor = $(this).attr('toepassing_outdoor');

    $('.verbruik_outdoor').text(verbruik);
    $('.afwasbaarheid_outdoor').text(afwasbaarheid_outdoor);
    $('.eigenschap_outdoor').text(eigenschap_outdoor);
    $('.afwerking_outdoor').text(afwerking_outdoor);
    $('.toepassing_outdoor').text(toepassing_outdoor);
    clearOutdoorValidationFeedback();
});

$(document).ready(function(){

    var checkedVal = $('.product-option-outdoor.Product input:checked').val();

    if(checkedVal){
        handleOptions(checkedVal);
    }

});


$(document).ready(function () {
if (window.location.href === "https://shadesbyerickuster.com/blogs/blog/hotel-chique-interieur") {
    window.location.href = "https://shadesbyerickuster.com/pages/hotel-chique";
}
if (window.location.href === "https://shadesbyerickuster.com/blogs/blog/hotel-chique-inspiratie-voor-elke-ruimte") {
    window.location.href = "https://shadesbyerickuster.com/pages/hotel-chique/ruimte";
}
if (window.location.href === "https://shadesbyerickuster.com/blogs/blog/hotel-chique-muurverf-gids-luxe-interieur") {
    window.location.href = "https://shadesbyerickuster.com/pages/hotel-chique/verf";
}
if (window.location.href === "https://shadesbyerickuster.com/blogs/blog/japandi-stijl-de-complete-interieurgids-2026") {
    window.location.href = "https://shadesbyerickuster.com/pages/japandi";
}
if (window.location.href === "https://shadesbyerickuster.com/blogs/blog/japandi-inspiratie-woonkamer-keuken-en-badkamer") {
    window.location.href = "https://shadesbyerickuster.com/pages/japandi/ruimte";
}
if (window.location.href === "https://shadesbyerickuster.com/blogs/blog/japandi-kleuren-voor-een-sereen-luxe-interieur") {
    window.location.href = "https://shadesbyerickuster.com/pages/japandi/kleuren";
}
if (window.location.href === "https://shadesbyerickuster.com/blogs/blog/kinderkamer-inspiratie-luxe-stijl-kleuradvies-van-eric-kuster") {
    window.location.href = "https://shadesbyerickuster.com/pages/kinderkamer";
}
if (window.location.href === "https://shadesbyerickuster.com/blogs/blog/complete-gids-voor-kinderkamer-kleuren-luxe-stijl-kleuradvies-van-eric-kuster") {
    window.location.href = "https://shadesbyerickuster.com/pages/kinderkamer/kleuren";
}
if (window.location.href === "https://shadesbyerickuster.com/blogs/blog/kinderkamer-stijlen-complete-gids-voor-boho-japandi-vintage-en-meer-2026") {
    window.location.href = "https://shadesbyerickuster.com/pages/kinderkamer/stijlen";
}
if (window.location.href === "https://shadesbyerickuster.com/blogs/news/kinderkamer-schilderen-veilige-verf-stap-voor-stap-gids-2026") {
    window.location.href = "https://shadesbyerickuster.com/pages/kinderkamer/verf";
}
if (window.location.href === "https://shadesbyerickuster.com/blogs/blog/badkamertrends-2026"){
    window.location.href = "https://shadesbyerickuster.com/pages/badkamer/trends-2026"
}
if (window.location.href === "https://shadesbyerickuster.com/blogs/blog/stappenplan-luxe-badkamer-samenstellen"){
    window.location.href = "https://shadesbyerickuster.com/pages/badkamer/luxe-badkamer-stappenplan"
}
});


/* tester */

$(function () {
    if (window.testerProductInitialized) {
        return;
    }

    window.testerProductInitialized = true;

    $(document).on('click', '[data-tester-product-add]', function () {
        var $button = $(this);

        if ($button.prop('disabled')) {
            return;
        }

        var $buttonText = $button.find('span');

        $button.prop('disabled', true).removeClass('is-error');
        $buttonText.text('Toevoegen...');

        $.ajax({
            url: window.Shopify.routes.root + 'cart/add.js',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify({
                id: Number($button.data('variant-id')),
                quantity: 1
            }),
            success: function (addedProduct) {
                $(document).trigger('ajaxProduct:added', {
                    product: addedProduct,
                    addToCartBtn: $button[0]
                });

                $button.closest('.tester_product').addClass('is-added');
            },
            error: function (xhr) {
                var error = xhr.responseJSON || {};

                $buttonText.text(error.description || 'Probeer opnieuw');
                $button
                    .addClass('is-error')
                    .prop('disabled', false);
            }
        });
    });
});


$('button.cb-i').click(function(){
    $(this).parent('.cb').find('.cb-how').toggleClass('open');
});


function cashback(){
  var totalQuantity = 0;
 var pprce = 0;
 
              $.getJSON('/cart.js', function(cart) {
                  cart.items.forEach(function(item) {
                      if (item.product_type === '100 ml testers' || item.product_type === 'color cards') {
                          totalQuantity += item.quantity;
                          pprce += item.line_price/100 ;
                           if (pprce > 0){
                            $('.cb-note span').text(pprce+',-');
                            $('.cb-note').show();
                           }else{
                             $('.cb-note').hide();
                           }
                      }
                  });
                 
                  if (totalQuantity === 0) {
                      pprce = 0;
                      $('.cb-note').hide();
                  }
                      var price = parseInt($('.pdp-total .act-price').attr('data-cmpare-price'), 10);
                      var qty = $('.product__quantity input.js-qty__num').val();
                      var mainprce = price * qty;
                      var total = (Number(mainprce) + Number(pprce));                 
                      $('.cb-line .amt').text('€' + total + ',-');           
            });
}
$(document).ready(function(){
   cashback()
})